(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5754],{

/***/ 30484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ bookpage_LicensingOptions; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(57135);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9970);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(15767);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/bookpage/licensing.module.scss
var licensing_module = __webpack_require__(84429);
var licensing_module_default = /*#__PURE__*/__webpack_require__.n(licensing_module);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var components_Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/Button/index.ts + 1 modules
var components_Button = __webpack_require__(32033);
// EXTERNAL MODULE: ./utils/licensingService.ts
var licensingService = __webpack_require__(63711);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/router.js
var next_router = __webpack_require__(96376);
// EXTERNAL MODULE: ./components/bookpage/subscriptions.module.scss
var subscriptions_module = __webpack_require__(87100);
var subscriptions_module_default = /*#__PURE__*/__webpack_require__.n(subscriptions_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-awesome-reveal@4.3.1_@emotion+react@11.14.0_@types+react@18.0.21_react@18.2.0_sup_9ec67bc2838b979fc11a3db5ae856235/node_modules/react-awesome-reveal/dist/index.js + 2 modules
var dist = __webpack_require__(56399);
// EXTERNAL MODULE: ./utils/subscriptionService.ts
var subscriptionService = __webpack_require__(78193);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(50156);
// EXTERNAL MODULE: ./components/bookpage/binary.module.scss
var binary_module = __webpack_require__(42172);
var binary_module_default = /*#__PURE__*/__webpack_require__.n(binary_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/axios@1.18.1_debug@4.4.3_supports-color@7.2.0__supports-color@7.2.0/node_modules/axios/lib/axios.js + 50 modules
var axios = __webpack_require__(81944);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hot-toast@2.6.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-hot-toast/dist/index.mjs + 1 modules
var react_hot_toast_dist = __webpack_require__(57337);
// EXTERNAL MODULE: ./node_modules/.pnpm/antd@5.29.3_date-fns@2.30.0_moment@2.30.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/antd/es/tooltip/index.js + 30 modules
var tooltip = __webpack_require__(95219);
// EXTERNAL MODULE: ./components/TextInput/TextInput.tsx
var TextInput = __webpack_require__(5166);
// EXTERNAL MODULE: ./components/ToastProvider/index.ts + 2 modules
var ToastProvider = __webpack_require__(51239);
;// CONCATENATED MODULE: ./components/bookpage/SubscriptionModal.tsx
/* provided dependency */ var process = __webpack_require__(82985);
















var API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || "https://api.vxfx.io" || 0;
// Map app name to icon path
var getIconSrcForApp = function(app) {
    var iconSrc = "";
    switch(app){
        case "DaVinci Resolve":
            iconSrc = "/logo/DaVinci_Resolve_Studio.svg";
            break;
        case "Adobe Premiere Pro":
            iconSrc = "/logo/Adobe_Premiere_Pro.svg";
            break;
        case "Sony VEGAS Pro":
            iconSrc = "/logo/Vegas_Pro.svg";
            break;
        case "Final Cut Pro":
            iconSrc = "/logo/Final_Cut_Pro.svg";
            break;
        case "Natron":
            iconSrc = "/logo/Natron.svg";
            break;
        case "Nuke":
            iconSrc = "/logo/Nuke.svg";
            break;
        case "Apple Motion":
            iconSrc = "/logo/Apple_Motion.svg";
            break;
        default:
            iconSrc = "";
    }
    return iconSrc;
};
var SubscriptionModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, topOffset = param.topOffset, productId = param.productId, externalSelectedPlanId = param.selectedPlanId;
    var ref = (0,react.useState)(2), currentStep = ref[0], setCurrentStep = ref[1];
    var ref1 = (0,react.useState)(null), selectedPlan = ref1[0], setSelectedPlan = ref1[1];
    var ref2 = (0,react.useState)(null), selectedPlanId = ref2[0], setSelectedPlanId = ref2[1];
    var ref3 = (0,react.useState)([]), selectedIds = ref3[0], setSelectedIds = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(null), error = ref5[0], setError = ref5[1];
    var ref6 = (0,react.useState)(false), purchaseLoading = ref6[0], setPurchaseLoading = ref6[1];
    var ref7 = (0,react.useState)([]), hosts = ref7[0], setHosts = ref7[1];
    var ref8 = (0,react.useState)(false), hostsLoading = ref8[0], setHostsLoading = ref8[1];
    var ref9 = (0,react.useState)("0"), additionalHosts = ref9[0], setAdditionalHosts = ref9[1];
    var ref10 = (0,react.useState)("0"), additionalHardware = ref10[0], setAdditionalHardware = ref10[1];
    var ref11 = (0,react.useState)(1), selectedDuration = ref11[0], setSelectedDuration = ref11[1];
    var ref12 = (0,react.useState)("eur"), currency = ref12[0], setCurrency = ref12[1];
    var ref13 = (0,react.useState)(null), product = ref13[0], setProduct = ref13[1];
    var ref14 = (0,react.useState)(false), productLoading = ref14[0], setProductLoading = ref14[1];
    var previousStepRef = (0,react.useRef)(2);
    // Convert hosts from API to HostOption format
    var hostOptions = (0,react.useMemo)(function() {
        var options = [];
        hosts.forEach(function(host) {
            options.push({
                id: host._id,
                name: host.name,
                displayName: host.displayName,
                icon: getIconSrcForApp(host.displayName)
            });
        });
        // remove duplicates
        options = options.filter(function(option, index, self) {
            return index === self.findIndex(function(t) {
                return t.id === option.id;
            });
        });
        return options;
    }, [
        hosts
    ]);
    // Reset flow when modal closes
    (0,react.useEffect)(function() {
        if (!isOpen) {
            setCurrentStep(2); // Start at step 2 (customization) since plan is already selected
            setHosts([]);
            setSelectedIds([]);
            setSelectedPlan(null);
            setSelectedPlanId(null);
            setAdditionalHosts("0");
            setAdditionalHardware("0");
            setSelectedDuration(1);
            setError(null);
        } else if (isOpen) {
            // When modal opens, go directly to step 2 (customization) - plan selection is removed
            setCurrentStep(2);
        }
    }, [
        isOpen,
        externalSelectedPlanId
    ]);
    // Update selectedDuration when plan changes
    (0,react.useEffect)(function() {
        if (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.duration) {
            setSelectedDuration(selectedPlan.duration);
        } else {
            setSelectedDuration(1);
        }
    }, [
        selectedPlan
    ]);
    // Load hosts when modal opens
    var loadHosts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, token, response, hostsData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, host, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, subItem, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, hostItem, e, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!productId) {
                            return [
                                2
                            ];
                        }
                        setHostsLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios/* default.get */.Z.get("".concat(API_BASE_URL, "/host?product=").concat(productId), {
                                headers: {
                                    Authorization: token ? "".concat(token) : "",
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if ((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.success) && (response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.data)) {
                            hostsData = [];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = response.data.data[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    host = _step.value;
                                    if (host.subItems) {
                                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(_iterator1 = Object.keys(host.subItems)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                subItem = _step1.value;
                                                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                                try {
                                                    for(_iterator2 = host.subItems[subItem][Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                        hostItem = _step2.value;
                                                        hostsData.push({
                                                            _id: hostItem,
                                                            name: hostItem,
                                                            displayName: hostItem
                                                        });
                                                    }
                                                } catch (err) {
                                                    _didIteratorError2 = true;
                                                    _iteratorError2 = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                            _iterator2.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError2) {
                                                            throw _iteratorError2;
                                                        }
                                                    }
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                    } else {
                                        hostsData.push(host);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            setHosts(hostsData);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        console.error("Error loading hosts:", e);
                        react_hot_toast_dist/* default.error */.ZP.error((e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || "Failed to load available hosts. Please try again.");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setHostsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadHosts() {
            return _ref.apply(this, arguments);
        };
    }();
    // Load hosts when modal opens
    (0,react.useEffect)(function() {
        if (isOpen && productId) {
            loadHosts();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        productId
    ]);
    // Update internal selectedPlanId when external prop changes
    (0,react.useEffect)(function() {
        if (externalSelectedPlanId) {
            setSelectedPlanId(externalSelectedPlanId);
        }
    }, [
        externalSelectedPlanId
    ]);
    // Load selected plan details when planId changes
    (0,react.useEffect)(function() {
        if (selectedPlanId) {
            subscriptionService/* subscriptionService.getPlanById */.A.getPlanById(selectedPlanId).then(function(plan) {
                setSelectedPlan(plan);
            }).catch(function(error) {
                console.error("Error loading plan:", error);
                react_hot_toast_dist/* default.error */.ZP.error("Failed to load plan details. Please try again.");
            });
        }
    }, [
        selectedPlanId
    ]);
    // Fetch product data for pricing
    (0,react.useEffect)(function() {
        if (!productId || !isOpen) return;
        var mounted = true;
        var fetchProduct = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var productData, ref, response, apiError, ref1, response1, actualProduct, e, ref2, ref3;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setProductLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                7,
                                8,
                                9
                            ]);
                            productData = null;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                6
                            ]);
                            return [
                                4,
                                axios/* default.get */.Z.get("".concat(API_BASE_URL, "/products/").concat(productId))
                            ];
                        case 3:
                            response = _state.sent();
                            if ((ref = response.data) === null || ref === void 0 ? void 0 : ref.data) {
                                productData = response.data.data;
                            } else if (response.data && !response.data.data) {
                                productData = response.data;
                            }
                            return [
                                3,
                                6
                            ];
                        case 4:
                            apiError = _state.sent();
                            return [
                                4,
                                axios/* default.get */.Z.get("".concat(API_BASE_URL, "/product-details/").concat(productId))
                            ];
                        case 5:
                            response1 = _state.sent();
                            if ((ref1 = response1.data) === null || ref1 === void 0 ? void 0 : ref1.data) {
                                productData = response1.data.data;
                            }
                            return [
                                3,
                                6
                            ];
                        case 6:
                            if (!mounted) return [
                                2
                            ];
                            if (productData) {
                                actualProduct = null;
                                if (Array.isArray(productData)) {
                                    actualProduct = productData[0];
                                } else if (productData.product) {
                                    actualProduct = productData.product;
                                } else {
                                    actualProduct = productData;
                                }
                                setProduct(actualProduct);
                            }
                            return [
                                3,
                                9
                            ];
                        case 7:
                            e = _state.sent();
                            if (!mounted) return [
                                2
                            ];
                            console.error("Error fetching product:", e);
                            setProduct(null);
                            react_hot_toast_dist/* default.error */.ZP.error((e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || "Failed to load pricing details. Please try again.");
                            return [
                                3,
                                9
                            ];
                        case 8:
                            if (mounted) {
                                setProductLoading(false);
                            }
                            return [
                                7
                            ];
                        case 9:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchProduct() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchProduct();
        return function() {
            mounted = false;
        };
    }, [
        productId,
        isOpen
    ]);
    // Limit additionalHosts when hosts are loaded
    (0,react.useEffect)(function() {
        if (hostOptions.length > 0 && additionalHosts && selectedPlan) {
            var currentValue = parseInt(additionalHosts);
            var maxAdditionalHosts = Math.max(0, hostOptions.length - selectedPlan.hostLimit);
            if (!isNaN(currentValue) && currentValue > maxAdditionalHosts) {
                setAdditionalHosts(maxAdditionalHosts.toString());
            }
        }
    }, [
        hostOptions.length,
        additionalHosts,
        selectedPlan
    ]);
    // Clear selections when step changes
    (0,react.useEffect)(function() {
        var prevStep = previousStepRef.current;
        if (currentStep === 2 && prevStep === 3 && selectedIds.length > 0) {
            setSelectedIds([]);
        }
        previousStepRef.current = currentStep;
    }, [
        currentStep,
        selectedIds.length
    ]);
    // Clear selections when plan or additional hosts count changes
    (0,react.useEffect)(function() {
        if (selectedIds.length > 0) {
            setSelectedIds([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan._id,
        additionalHosts
    ]);
    var toggleSelection = function(id, maxAllowed) {
        setSelectedIds(function(prev) {
            if (prev.includes(id)) {
                return prev.filter(function(x) {
                    return x !== id;
                });
            } else {
                if (prev.length < maxAllowed) {
                    return (0,_to_consumable_array/* default */.Z)(prev).concat([
                        id
                    ]);
                }
                return prev;
            }
        });
    };
    // Calculate Step 2 pricing
    var step2Pricing = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
        if (!selectedPlan) return null;
        var basePlanPrice = selectedPlan.price[currency];
        var additionalHostsCount = additionalHosts ? parseInt(additionalHosts, 10) || 0 : 0;
        var additionalHardwareCount = additionalHardware ? parseInt(additionalHardware, 10) || 0 : 0;
        var ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31;
        // Prices per unit (from product API - use subscription-specific prices first)
        var perHostPriceValue = (ref31 = (ref30 = (ref29 = (ref28 = (ref27 = (ref26 = (ref25 = (ref24 = product === null || product === void 0 ? void 0 : (ref = product.subscriptionAdditionalHostPrice) === null || ref === void 0 ? void 0 : ref[currency]) !== null && ref24 !== void 0 ? ref24 : product === null || product === void 0 ? void 0 : (ref1 = product.subscriptionAdditionalHostPrice) === null || ref1 === void 0 ? void 0 : ref1.eur) !== null && ref25 !== void 0 ? ref25 : product === null || product === void 0 ? void 0 : (ref2 = product.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscriptionAdditionalHostPrice) === null || ref3 === void 0 ? void 0 : ref3[currency]) !== null && ref26 !== void 0 ? ref26 : product === null || product === void 0 ? void 0 : (ref4 = product.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.subscriptionAdditionalHostPrice) === null || ref5 === void 0 ? void 0 : ref5.eur) !== null && ref27 !== void 0 ? ref27 : product === null || product === void 0 ? void 0 : (ref6 = product.additionalHostPrice) === null || ref6 === void 0 ? void 0 : ref6[currency]) !== null && ref28 !== void 0 ? ref28 : product === null || product === void 0 ? void 0 : (ref7 = product.additionalHostPrice) === null || ref7 === void 0 ? void 0 : ref7.eur) !== null && ref29 !== void 0 ? ref29 : product === null || product === void 0 ? void 0 : (ref8 = product.product) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.additionalHostPrice) === null || ref9 === void 0 ? void 0 : ref9[currency]) !== null && ref30 !== void 0 ? ref30 : product === null || product === void 0 ? void 0 : (ref10 = product.product) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.additionalHostPrice) === null || ref11 === void 0 ? void 0 : ref11.eur) !== null && ref31 !== void 0 ? ref31 : 0;
        var ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39;
        var perHardwarePriceValue = (ref39 = (ref38 = (ref37 = (ref36 = (ref35 = (ref34 = (ref33 = (ref32 = product === null || product === void 0 ? void 0 : (ref12 = product.subscriptionAdditionalHardwarePrice) === null || ref12 === void 0 ? void 0 : ref12[currency]) !== null && ref32 !== void 0 ? ref32 : product === null || product === void 0 ? void 0 : (ref13 = product.subscriptionAdditionalHardwarePrice) === null || ref13 === void 0 ? void 0 : ref13.eur) !== null && ref33 !== void 0 ? ref33 : product === null || product === void 0 ? void 0 : (ref14 = product.product) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.subscriptionAdditionalHardwarePrice) === null || ref15 === void 0 ? void 0 : ref15[currency]) !== null && ref34 !== void 0 ? ref34 : product === null || product === void 0 ? void 0 : (ref16 = product.product) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.subscriptionAdditionalHardwarePrice) === null || ref17 === void 0 ? void 0 : ref17.eur) !== null && ref35 !== void 0 ? ref35 : product === null || product === void 0 ? void 0 : (ref18 = product.additionalHardwarePrice) === null || ref18 === void 0 ? void 0 : ref18[currency]) !== null && ref36 !== void 0 ? ref36 : product === null || product === void 0 ? void 0 : (ref19 = product.additionalHardwarePrice) === null || ref19 === void 0 ? void 0 : ref19.eur) !== null && ref37 !== void 0 ? ref37 : product === null || product === void 0 ? void 0 : (ref20 = product.product) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.additionalHardwarePrice) === null || ref21 === void 0 ? void 0 : ref21[currency]) !== null && ref38 !== void 0 ? ref38 : product === null || product === void 0 ? void 0 : (ref22 = product.product) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.additionalHardwarePrice) === null || ref23 === void 0 ? void 0 : ref23.eur) !== null && ref39 !== void 0 ? ref39 : 0;
        // Calculate base costs
        var additionalHostsCost = additionalHostsCount * perHostPriceValue;
        var additionalHardwareCost = additionalHardwareCount * perHardwarePriceValue;
        // Calculate monthly price
        var monthlyPrice = basePlanPrice + additionalHostsCost + additionalHardwareCost;
        // Calculate total price (monthlyPrice × duration)
        var totalPrice = monthlyPrice * selectedDuration;
        return {
            basePlan: {
                price: basePlanPrice
            },
            additionalHosts: {
                price: additionalHostsCost
            },
            additionalHardware: {
                price: additionalHardwareCost
            },
            perHostPrice: perHostPriceValue,
            perHardwarePrice: perHardwarePriceValue,
            monthly: {
                price: monthlyPrice
            },
            total: {
                price: totalPrice
            }
        };
    }, [
        selectedPlan,
        additionalHosts,
        additionalHardware,
        product,
        currency,
        selectedDuration
    ]);
    // Handle purchase from step 3
    var handlePurchase = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var token, selectedHostNames, planHostLimit, additionalHostsCount, allHostsIncluded, additionalHostsCountFinal, additionalHardwareCountFinal, selectedDurationFinal, maxWorkflowRunsPerProductFinal, checkout, e, ref, ref1, errorMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!selectedPlanId || !selectedPlan) {
                            react_hot_toast_dist/* default.error */.ZP.error("Please select a plan to continue.");
                            return [
                                2
                            ];
                        }
                        token = localStorage.getItem("auth-token");
                        if (!token) {
                            localStorage.setItem("redirectTo", window.location.pathname + window.location.search);
                            onClose();
                            window.location.href = "/login";
                            return [
                                2
                            ];
                        }
                        selectedHostNames = selectedIds.map(function(id) {
                            var host = hosts.find(function(h) {
                                return h._id === id;
                            });
                            return (host === null || host === void 0 ? void 0 : host.name) || (host === null || host === void 0 ? void 0 : host.displayName);
                        }).filter(function(name) {
                            return !!name;
                        });
                        // If no hosts selected but all hosts are included in plan, auto-select all
                        if (selectedHostNames.length === 0 && selectedPlan && hostOptions.length > 0) {
                            planHostLimit = selectedPlan.hostLimit || 0;
                            additionalHostsCount = parseInt(additionalHosts) || 0;
                            allHostsIncluded = hostOptions.length <= planHostLimit && additionalHostsCount === 0;
                            if (allHostsIncluded) {
                                // Auto-select all hosts
                                selectedHostNames = hostOptions.map(function(opt) {
                                    return opt.name || opt.displayName;
                                });
                                setSelectedIds(hostOptions.map(function(opt) {
                                    return opt.id;
                                }));
                            }
                        }
                        // Validation: supports is required and must have at least one item
                        if (selectedHostNames.length === 0) {
                            react_hot_toast_dist/* default.error */.ZP.error("Please select at least one host.");
                            setError("Please select at least one host.");
                            return [
                                2
                            ];
                        }
                        setPurchaseLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        additionalHostsCountFinal = parseInt(additionalHosts) || 0;
                        additionalHardwareCountFinal = parseInt(additionalHardware) || 0;
                        selectedDurationFinal = selectedDuration || selectedPlan.duration || 1;
                        maxWorkflowRunsPerProductFinal = selectedPlan.hardwareLimit || 1;
                        return [
                            4,
                            subscriptionService/* subscriptionService.createCheckoutSession */.A.createCheckoutSession(selectedPlanId, currency, {
                                additionalHosts: additionalHostsCountFinal,
                                additionalHardware: additionalHardwareCountFinal,
                                supports: selectedHostNames,
                                selectedDuration: selectedDurationFinal,
                                maxWorkflowRunsPerProduct: maxWorkflowRunsPerProductFinal
                            })
                        ];
                    case 2:
                        checkout = _state.sent();
                        // Free plan: subscription is already active, no Stripe redirect needed.
                        // window.location.href is a hard navigation that tears down the JS
                        // runtime, so the toast is queued in sessionStorage and flushed by
                        // <ToastProvider/> once the destination page mounts.
                        if (checkout.free) {
                            (0,ToastProvider/* queueToast */.Q5)("success", "Subscription activated! We've emailed your confirmation — redirecting you to My Subscriptions.");
                            window.location.href = "/members-area?tab=mysubscriptions";
                        } else if (checkout.url) {
                            window.location.href = checkout.url;
                        } else {
                            react_hot_toast_dist/* default.error */.ZP.error("Something went wrong with the payment server. Please try again.");
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        console.error("Error creating checkout session:", e);
                        errorMessage = (e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || (e === null || e === void 0 ? void 0 : e.message) || "Failed to create checkout session. Please try again.";
                        react_hot_toast_dist/* default.error */.ZP.error(errorMessage);
                        setError(errorMessage);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setPurchaseLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePurchase() {
            return _ref.apply(this, arguments);
        };
    }();
    // Tooltip icon component for inputs
    var HelpTooltipIcon = function(param) {
        var title = param.title;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
            title: title,
            placement: "top",
            overlayInnerStyle: {
                backgroundColor: "#2a2a2a",
                maxWidth: "300px",
                zIndex: 10002
            },
            getPopupContainer: function() {
                return document.body;
            },
            overlayClassName: (binary_module_default()).tooltipOverlay,
            zIndex: 10002,
            destroyTooltipOnHide: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "absolute",
                    right: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    color: "var(--color-gray-dark-500)",
                    pointerEvents: "auto",
                    zIndex: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/help.svg",
                    alt: "Help",
                    width: "16",
                    height: "16"
                })
            })
        });
    };
    // Step 1: Plan Selection - REMOVED: Plans are now selected outside the modal
    // Step 2: Customize
    var renderStep2 = function() {
        var ref, ref1;
        if (!selectedPlan) return null;
        var pricing = step2Pricing;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (binary_module_default()).step1Content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (binary_module_default()).selectedPackageCard,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (binary_module_default()).selectedPackageIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/packageIllustration.svg",
                                alt: "Plan"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).selectedPackageText,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (binary_module_default()).selectedPackageTitleRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "grayDark-300",
                                            weight: "medium",
                                            children: "Selected plan:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "grayDark-400",
                                            children: selectedPlan.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    style: {
                                        marginTop: 4
                                    },
                                    children: [
                                        "Base configuration includes: ",
                                        selectedPlan.hostLimit,
                                        " supported hosts,",
                                        " ",
                                        selectedPlan.hardwareLimit,
                                        " development machines"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (binary_module_default()).additionalOptions,
                    children: [
                        function() {
                            var ref;
                            var maxAdditionalHosts = Math.max(0, hostOptions.length - selectedPlan.hostLimit);
                            if (maxAdditionalHosts === 0) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (binary_module_default()).optionField,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        color: "grayDark-300",
                                        weight: "medium",
                                        children: "Number of additional hosts"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                        placeholder: "Enter number of additional hosts",
                                        value: additionalHosts,
                                        onChange: function(e) {
                                            var value = e.target.value.replace(/[^0-9]/g, "");
                                            if (value === "") {
                                                setAdditionalHosts("");
                                            } else {
                                                var numValue = parseInt(value);
                                                if (!isNaN(numValue)) {
                                                    if (maxAdditionalHosts > 0 && numValue > maxAdditionalHosts) {
                                                        setAdditionalHosts(maxAdditionalHosts.toString());
                                                    } else {
                                                        setAdditionalHosts(value);
                                                    }
                                                }
                                            }
                                        },
                                        fullWidth: true,
                                        type: "number",
                                        max: maxAdditionalHosts > 0 ? maxAdditionalHosts : undefined,
                                        helperText: maxAdditionalHosts > 0 && pricing ? "Maximum ".concat(maxAdditionalHosts, " additional hosts available (").concat(currency === "usd" ? "$" : "€").concat(productLoading ? "..." : pricing.perHostPrice.toLocaleString(), " per host)") : undefined,
                                        rightElement: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpTooltipIcon, {
                                            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                        variant: "text-sm",
                                                        color: "grayDark-50",
                                                        weight: "semibold",
                                                        children: "Additional Hosts"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                        variant: "text-sm",
                                                        color: "grayDark-400",
                                                        style: {
                                                            marginTop: 8
                                                        },
                                                        children: [
                                                            "Enter the number of additional hosts you need beyond the base plan configuration. Each additional host costs",
                                                            " ",
                                                            currency === "usd" ? "$" : "€",
                                                            productLoading ? "..." : (pricing === null || pricing === void 0 ? void 0 : (ref = pricing.perHostPrice) === null || ref === void 0 ? void 0 : ref.toLocaleString()) || "0",
                                                            " ",
                                                            "per ",
                                                            selectedPlan.billingCycle === "yearly" ? "year" : "month",
                                                            ".",
                                                            maxAdditionalHosts > 0 && " Maximum: ".concat(maxAdditionalHosts, " additional hosts.")
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            });
                        }(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).optionField,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-300",
                                    weight: "medium",
                                    children: "Number of additional development machines"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                    placeholder: "Enter number of additional development machines",
                                    value: additionalHardware,
                                    onChange: function(e) {
                                        var value = e.target.value.replace(/[^0-9]/g, "");
                                        setAdditionalHardware(value);
                                    },
                                    fullWidth: true,
                                    type: "number",
                                    rightElement: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpTooltipIcon, {
                                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                    variant: "text-sm",
                                                    color: "grayDark-50",
                                                    weight: "semibold",
                                                    children: "Additional Development Machines"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                    variant: "text-sm",
                                                    color: "grayDark-400",
                                                    style: {
                                                        marginTop: 8
                                                    },
                                                    children: [
                                                        "Enter the number of additional development machines you need beyond the base plan configuration. Each additional development machine costs",
                                                        " ",
                                                        currency === "usd" ? "$" : "€",
                                                        productLoading ? "..." : (pricing === null || pricing === void 0 ? void 0 : (ref = pricing.perHardwarePrice) === null || ref === void 0 ? void 0 : ref.toLocaleString()) || "0",
                                                        " ",
                                                        "per ",
                                                        selectedPlan.billingCycle === "yearly" ? "year" : "month",
                                                        "."
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    style: {
                                        marginTop: 8
                                    },
                                    children: [
                                        currency === "usd" ? "$" : "€",
                                        productLoading ? "..." : (pricing === null || pricing === void 0 ? void 0 : (ref1 = pricing.perHardwarePrice) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString()) || "0",
                                        " per development machine"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).optionField,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-300",
                                    weight: "medium",
                                    children: "Subscription Duration (months)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                    placeholder: "Enter duration in months",
                                    value: selectedDuration.toString(),
                                    onChange: function(e) {
                                        var value = e.target.value.replace(/[^0-9]/g, "");
                                        if (value === "") {
                                            setSelectedDuration(1);
                                        } else {
                                            var numValue = parseInt(value);
                                            if (!isNaN(numValue)) {
                                                if (numValue < 1) {
                                                    setSelectedDuration(1);
                                                } else if (numValue > 12) {
                                                    setSelectedDuration(12);
                                                } else {
                                                    setSelectedDuration(numValue);
                                                }
                                            }
                                        }
                                    },
                                    fullWidth: true,
                                    type: "number",
                                    min: 1,
                                    max: 12,
                                    rightElement: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpTooltipIcon, {
                                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                    variant: "text-sm",
                                                    color: "grayDark-50",
                                                    weight: "semibold",
                                                    children: "Subscription Duration"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                    variant: "text-sm",
                                                    color: "grayDark-400",
                                                    style: {
                                                        marginTop: 8
                                                    },
                                                    children: "Select the duration of your subscription. You can choose between 1 to 12 months. The total price will be calculated based on the monthly price multiplied by the selected duration."
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    style: {
                                        marginTop: 8
                                    },
                                    children: "Minimum: 1 month, Maximum: 12 months"
                                })
                            ]
                        })
                    ]
                }),
                pricing && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (binary_module_default()).priceSummary,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                            variant: "text-md",
                            color: "grayDark-50",
                            weight: "semibold",
                            style: {
                                marginBottom: 16
                            },
                            children: "Price Summary"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).priceRow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    children: "Base Plan"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (binary_module_default()).priceValues,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        color: "grayDark-50",
                                        weight: "semibold",
                                        children: [
                                            currency === "usd" ? "$" : "€",
                                            Math.round(pricing.basePlan.price).toLocaleString()
                                        ]
                                    })
                                })
                            ]
                        }),
                        function() {
                            var maxAdditionalHosts = Math.max(0, hostOptions.length - selectedPlan.hostLimit);
                            if (maxAdditionalHosts === 0) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (binary_module_default()).priceRow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        color: "grayDark-400",
                                        children: [
                                            "Additional supported hosts (",
                                            currency === "usd" ? "$" : "€",
                                            productLoading ? "..." : pricing.perHostPrice.toLocaleString(),
                                            " per host)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (binary_module_default()).priceValues,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "grayDark-50",
                                            weight: "semibold",
                                            children: [
                                                currency === "usd" ? "$" : "€",
                                                Math.round(pricing.additionalHosts.price).toLocaleString()
                                            ]
                                        })
                                    })
                                ]
                            });
                        }(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).priceRow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    children: [
                                        "Additional development machines (",
                                        currency === "usd" ? "$" : "€",
                                        productLoading ? "..." : pricing.perHardwarePrice.toLocaleString(),
                                        " per development machine)"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (binary_module_default()).priceValues,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        color: "grayDark-50",
                                        weight: "semibold",
                                        children: [
                                            currency === "usd" ? "$" : "€",
                                            Math.round(pricing.additionalHardware.price).toLocaleString()
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).priceRow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    children: "Monthly Price"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (binary_module_default()).priceValues,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        color: "grayDark-50",
                                        weight: "semibold",
                                        children: [
                                            currency === "usd" ? "$" : "€",
                                            Math.round(pricing.monthly.price).toLocaleString(),
                                            "/month"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).priceRow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    children: "Duration"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (binary_module_default()).priceValues,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        color: "grayDark-50",
                                        weight: "semibold",
                                        children: [
                                            selectedDuration,
                                            " month",
                                            selectedDuration !== 1 ? "s" : ""
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).priceRowTotal,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-md",
                                    color: "grayDark-50",
                                    weight: "semibold",
                                    children: "Total price"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (binary_module_default()).priceValues,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                        variant: "text-md",
                                        color: "grayDark-50",
                                        weight: "semibold",
                                        children: [
                                            currency === "usd" ? "$" : "€",
                                            Math.round(pricing.total.price).toLocaleString()
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    // Step 3: Host Selection
    var renderStep3 = function() {
        // Calculate max allowed selections: plan hostLimit + additional hosts
        var planHostLimit = (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.hostLimit) || 0;
        var additionalHostsCount = parseInt(additionalHosts) || 0;
        var maxAllowedSelections = planHostLimit + additionalHostsCount;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: purchaseLoading ? (binary_module_default()).contentDisabled : "",
            "aria-disabled": purchaseLoading,
            children: [
                error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginBottom: 12,
                        color: "#ff6961"
                    },
                    children: error
                }) : null,
                maxAllowedSelections > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                    variant: "text-sm",
                    color: "grayDark-400",
                    style: {
                        marginBottom: 16
                    },
                    children: [
                        "Select up to ",
                        maxAllowedSelections,
                        " host",
                        maxAllowedSelections !== 1 ? "s" : "",
                        " (",
                        selectedIds.length,
                        "/",
                        maxAllowedSelections,
                        " selected)"
                    ]
                }),
                hostsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (binary_module_default()).grid,
                    children: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6
                    ].map(function(index) {
                        var widths = [
                            150,
                            180,
                            140,
                            160,
                            170,
                            155
                        ];
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).hostSkeletonCard,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (binary_module_default()).hostSkeletonLeft,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (binary_module_default()).hostSkeletonIcon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (binary_module_default()).hostSkeletonText,
                                            style: {
                                                width: "".concat(widths[index - 1], "px")
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (binary_module_default()).hostSkeletonCheck
                                })
                            ]
                        }, index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (binary_module_default()).grid,
                    children: hostOptions.map(function(host) {
                        var selected = selectedIds.includes(host.id);
                        var isDisabled = !selected && selectedIds.length >= maxAllowedSelections;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "".concat((binary_module_default()).hostCard, " ").concat(selected ? (binary_module_default()).selected : "", " ").concat(isDisabled ? (binary_module_default()).disabled : ""),
                            onClick: function() {
                                return toggleSelection(host.id, maxAllowedSelections);
                            },
                            "aria-pressed": selected,
                            disabled: purchaseLoading || isDisabled,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (binary_module_default()).hostLeft,
                                    children: [
                                        host.icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: host.icon,
                                            alt: "",
                                            "aria-hidden": "true",
                                            style: {
                                                width: "32px",
                                                height: "32px"
                                            }
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                            variant: "text-lg",
                                            color: "grayDark-50",
                                            weight: "medium",
                                            children: host.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (binary_module_default()).check
                                })
                            ]
                        }, host.id);
                    })
                })
            ]
        });
    };
    // Get title based on current step
    var getModalTitle = function() {
        if (currentStep === 2) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 12,
                        position: "relative",
                        zIndex: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                position: "relative",
                                width: 48,
                                height: 48,
                                flexShrink: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/modal-background-pattern.svg",
                                    alt: "",
                                    "aria-hidden": "true",
                                    style: {
                                        position: "absolute",
                                        top: -24,
                                        left: -24,
                                        width: 216,
                                        height: 217,
                                        opacity: 0.9,
                                        pointerEvents: "none",
                                        zIndex: 0
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/customIllustration.svg",
                                    alt: "Customize"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                zIndex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-lg",
                                    color: "grayDark-50",
                                    weight: "semibold",
                                    children: "Customize your subscription"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    children: "Configure your subscription plan with additional hosts, machines, and duration."
                                })
                            ]
                        })
                    ]
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 12,
                        position: "relative",
                        zIndex: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                position: "relative",
                                width: 48,
                                height: 48,
                                flexShrink: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/modal-background-pattern.svg",
                                    alt: "",
                                    "aria-hidden": "true",
                                    style: {
                                        position: "absolute",
                                        top: -24,
                                        left: -24,
                                        width: 216,
                                        height: 217,
                                        opacity: 0.9,
                                        pointerEvents: "none",
                                        zIndex: 0
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/hostIllustration.svg",
                                    alt: "Host"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                zIndex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-lg",
                                    color: "grayDark-50",
                                    weight: "semibold",
                                    children: "Select your host"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    children: "Choose your preferred host to generate a custom binary license."
                                })
                            ]
                        })
                    ]
                })
            });
        }
    };
    // Get footer based on current step
    var getModalFooter = function() {
        if (currentStep === 2) {
            // Calculate if we should skip step 3
            var planHostLimit = (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.hostLimit) || 0;
            var additionalHostsCount = parseInt(additionalHosts) || 0;
            var maxAllowedSelections = planHostLimit + additionalHostsCount;
            var allHostsIncluded = selectedPlan && hostOptions.length > 0 && hostOptions.length <= planHostLimit && additionalHostsCount === 0;
            var shouldSkipStep3 = allHostsIncluded || maxAllowedSelections === 0;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (binary_module_default()).footerActions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                        variant: "secondary",
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                        variant: "primary",
                        onClick: function() {
                            if (shouldSkipStep3) {
                                // If all hosts are included, auto-select all and proceed to purchase
                                if (allHostsIncluded && hostOptions.length > 0) {
                                    setSelectedIds(hostOptions.map(function(opt) {
                                        return opt.id;
                                    }));
                                }
                                handlePurchase();
                            } else {
                                setCurrentStep(3);
                            }
                        },
                        disabled: !selectedPlan,
                        loading: shouldSkipStep3 && purchaseLoading,
                        children: shouldSkipStep3 ? "Purchase" : "Continue"
                    })
                ]
            });
        } else {
            // Step 3 footer
            var planHostLimit1 = (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.hostLimit) || 0;
            var additionalHostsCount1 = parseInt(additionalHosts) || 0;
            var maxAllowedSelections1 = planHostLimit1 + additionalHostsCount1;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (binary_module_default()).footerActions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                        variant: "secondary",
                        onClick: function() {
                            return setCurrentStep(2);
                        },
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                        variant: "primary",
                        onClick: handlePurchase,
                        disabled: selectedIds.length !== maxAllowedSelections1 || hostsLoading || hosts.length === 0 || purchaseLoading || maxAllowedSelections1 === 0 || !selectedPlanId,
                        loading: purchaseLoading,
                        children: "Purchase"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hot_toast_dist/* Toaster */.x7, {
                position: "bottom-center",
                reverseOrder: false,
                containerStyle: {
                    zIndex: 10001
                },
                toastOptions: {
                    style: {
                        zIndex: 10001
                    }
                },
                gutter: 8
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                isOpen: isOpen,
                onClose: purchaseLoading ? function() {} : onClose,
                topOffset: topOffset,
                maxWidth: 880,
                title: getModalTitle(),
                footer: getModalFooter(),
                children: [
                    currentStep === 2 && renderStep2(),
                    currentStep === 3 && renderStep3()
                ]
            })
        ]
    });
};
/* harmony default export */ var bookpage_SubscriptionModal = (SubscriptionModal);

// EXTERNAL MODULE: ./data/products.ts
var products = __webpack_require__(7069);
;// CONCATENATED MODULE: ./components/bookpage/Subscriptions.tsx













var CircleBoltIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 48 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
                fill: "#7F56D9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9989 14L16.0923 24.6879C15.7435 25.1064 15.5691 25.3157 15.5665 25.4925C15.5641 25.6461 15.6326 25.7923 15.7521 25.8889C15.8896 26 16.1621 26 16.7069 26H23.9989L22.9989 34L31.9054 23.3121C32.2542 22.8936 32.4286 22.6843 32.4313 22.5075C32.4336 22.3539 32.3652 22.2077 32.2456 22.1111C32.1081 22 31.8357 22 31.2909 22H23.9989L24.9989 14Z",
                stroke: "#E9D7FE",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var CheckIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 24 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
                fill: "#9E77ED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.098 7.39004L9.93797 14.3L8.03797 12.27C7.68797 11.94 7.13797 11.92 6.73797 12.2C6.34797 12.49 6.23797 13 6.47797 13.41L8.72797 17.07C8.94797 17.41 9.32797 17.62 9.75797 17.62C10.168 17.62 10.558 17.41 10.778 17.07C11.138 16.6 18.008 8.41004 18.008 8.41004C18.908 7.49004 17.818 6.68004 17.098 7.38004V7.39004Z",
                fill: "#E9D7FE"
            })
        ]
    });
};
var Subscriptions = function(param) {
    var _selectedPlanId = param.selectedPlanId, selectedPlanId = _selectedPlanId === void 0 ? null : _selectedPlanId, onSelect = param.onSelect, onWidthChange = param.onWidthChange, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, externalCurrency = param.currency, onCurrencyChange = param.onCurrencyChange;
    var router = (0,next_router.useRouter)();
    var slug = router.query.url || "";
    var productId = slug ? (0,products/* getProductIdBySlug */.WO)(slug) || "" : "";
    var ref = (0,react.useState)([]), plans = ref[0], setPlans = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)("eur"), internalCurrency = ref2[0], setInternalCurrency = ref2[1];
    var currency = externalCurrency !== undefined ? externalCurrency : internalCurrency;
    var ref3 = (0,react.useState)(false), modalOpen = ref3[0], setModalOpen = ref3[1];
    var ref4 = (0,react.useState)(null), modalSelectedPlanId = ref4[0], setModalSelectedPlanId = ref4[1];
    var ref5 = (0,react.useState)(false), isMobile = ref5[0], setIsMobile = ref5[1];
    var fetchPlans = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, sortedPlans, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setLoading(true);
                        return [
                            4,
                            subscriptionService/* subscriptionService.getPlans */.A.getPlans({
                                isActive: true,
                                hidden: false
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        sortedPlans = (0,_to_consumable_array/* default */.Z)(data).sort(function(a, b) {
                            var priceA = currency === "usd" ? a.price.usd : a.price.eur;
                            var priceB = currency === "usd" ? b.price.usd : b.price.eur;
                            return priceA - priceB;
                        });
                        setPlans(sortedPlans);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        console.error("Error fetching subscription plans:", error);
                        setPlans([]);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchPlans() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchPlans();
        // Detect user currency preference
        if (externalCurrency === undefined) {
            var userLang =  true ? navigator.language : 0;
            if (userLang.toLowerCase().includes("eu") || userLang.toLowerCase().includes("de") || userLang.toLowerCase().includes("fr")) {
                var detectedCurrency = "eur";
                setInternalCurrency(detectedCurrency);
                onCurrencyChange === null || onCurrencyChange === void 0 ? void 0 : onCurrencyChange(detectedCurrency);
            } else {
                var detectedCurrency1 = "eur";
                setInternalCurrency(detectedCurrency1);
                onCurrencyChange === null || onCurrencyChange === void 0 ? void 0 : onCurrencyChange(detectedCurrency1);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalCurrency,
        onCurrencyChange
    ]);
    (0,react.useEffect)(function() {
        var onResize = function() {
            setIsMobile( true && window.innerWidth <= 480);
        };
        onResize();
        window.addEventListener("resize", onResize);
        return function() {
            window.removeEventListener("resize", onResize);
        };
    }, []);
    // Re-sort plans when currency changes
    (0,react.useEffect)(function() {
        if (plans.length > 0) {
            setPlans(function(prevPlans) {
                var sortedPlans = (0,_to_consumable_array/* default */.Z)(prevPlans).sort(function(a, b) {
                    var priceA = currency === "usd" ? a.price.usd : a.price.eur;
                    var priceB = currency === "usd" ? b.price.usd : b.price.eur;
                    return priceA - priceB;
                });
                return sortedPlans;
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currency
    ]);
    var handleCurrencyChange = function(newCurrency) {
        if (externalCurrency === undefined) {
            setInternalCurrency(newCurrency);
        }
        onCurrencyChange === null || onCurrencyChange === void 0 ? void 0 : onCurrencyChange(newCurrency);
    };
    var handleSelectCard = function(planId) {
        setModalSelectedPlanId(planId);
        setModalOpen(true);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(planId);
    };
    var formatPrice = function(price, selectedCurrency) {
        var amount = selectedCurrency === "usd" ? price.usd : price.eur;
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: selectedCurrency.toUpperCase(),
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };
    // Default plans if API returns empty (for demo/fallback)
    var defaultPlans = [
        {
            _id: "1",
            name: "Basic plan",
            description: "Basic features for up to 10 users.",
            hostLimit: 5,
            hardwareLimit: 2,
            price: {
                usd: 10,
                eur: 9
            },
            billingCycle: "monthly",
            features: [
                "Access to basic features",
                "Basic reporting and analytics",
                "Up to 10 individual users",
                "20 GB individual data",
                "Basic chat and email support", 
            ],
            duration: 1,
            isActive: true,
            hidden: false,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
        },
        {
            _id: "2",
            name: "Business plan",
            description: "Advanced features and reporting.",
            hostLimit: 15,
            hardwareLimit: 5,
            price: {
                usd: 20,
                eur: 18
            },
            billingCycle: "monthly",
            features: [
                "Access to basic features",
                "Basic reporting and analytics",
                "Up to 10 individual users",
                "20 GB individual data",
                "Basic chat and email support", 
            ],
            duration: 1,
            isActive: true,
            hidden: false,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
        },
        {
            _id: "3",
            name: "Enterprise plan",
            description: "Unlimited features.",
            hostLimit: 50,
            hardwareLimit: 10,
            price: {
                usd: 40,
                eur: 36
            },
            billingCycle: "monthly",
            features: [
                "Access to basic features",
                "Basic reporting and analytics",
                "Up to 10 individual users",
                "20 GB individual data",
                "Basic chat and email support", 
            ],
            duration: 1,
            isActive: true,
            hidden: false,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
        }, 
    ];
    // Sort default plans by price as well
    var sortedDefaultPlans = (0,_to_consumable_array/* default */.Z)(defaultPlans).sort(function(a, b) {
        var priceA = currency === "usd" ? a.price.usd : a.price.eur;
        var priceB = currency === "usd" ? b.price.usd : b.price.eur;
        return priceA - priceB;
    });
    var displayPlans = plans.length > 0 ? plans : sortedDefaultPlans;
    // Compute modal width to fit exact number of cards (1-3)
    (0,react.useEffect)(function() {
        var count = loading && plans.length === 0 ? 3 : Math.min(displayPlans.length, 3);
        var cardWidth = 340; // px
        var gap = 32; // from styles.plansGrid
        var modalBodyPadding = 48; // Modal content padding (24 left + 24 right)
        var width = count * cardWidth + Math.max(0, count - 1) * gap + modalBodyPadding;
        onWidthChange === null || onWidthChange === void 0 ? void 0 : onWidthChange(width);
    }, [
        displayPlans.length,
        loading,
        plans.length,
        onWidthChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (subscriptions_module_default()).subscriptionsContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((subscriptions_module_default()).subscriptionsContent, " ").concat(isDisabled ? (subscriptions_module_default()).contentDisabled : ""),
                    "aria-disabled": isDisabled,
                    children: loading && plans.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (subscriptions_module_default()).loading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (subscriptions_module_default()).plansGrid,
                            children: [
                                0,
                                1,
                                2,
                                3
                            ].map(function(i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (subscriptions_module_default()).planCard,
                                    style: {
                                        opacity: 0.4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                justifyContent: "center",
                                                marginBottom: 8
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (subscriptions_module_default()).skeletonIcon
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (subscriptions_module_default()).skeletonTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (subscriptions_module_default()).skeletonPrice
                                        }),
                                        [
                                            0,
                                            1,
                                            2,
                                            3,
                                            4
                                        ].map(function(j) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (subscriptions_module_default()).skeletonFeature,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (subscriptions_module_default()).skeletonCheckIcon
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (subscriptions_module_default()).skeletonFeatureText,
                                                        style: {
                                                            width: "".concat(70 + j * 10, "%")
                                                        }
                                                    })
                                                ]
                                            }, j);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (subscriptions_module_default()).skeletonButtonContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (subscriptions_module_default()).skeletonButton
                                            })
                                        })
                                    ]
                                }, i);
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((subscriptions_module_default()).plansGrid, " ").concat(displayPlans.length === 1 ? (subscriptions_module_default()).singleGrid : displayPlans.length === 2 ? (subscriptions_module_default()).twoGrid : ""),
                        children: displayPlans.map(function(plan, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                triggerOnce: true,
                                duration: 1000,
                                delay: index * 200,
                                style: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (subscriptions_module_default()).planCard,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (subscriptions_module_default()).planHeader,
                                            style: {
                                                alignItems: "center",
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        marginBottom: 8,
                                                        display: "inline-flex"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleBoltIcon, {
                                                        size: 48
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                    variant: "text-xl",
                                                    color: "grayDark-50",
                                                    weight: "semibold",
                                                    children: plan.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                    variant: "display-lg",
                                                    color: "grayDark-50",
                                                    weight: "semibold",
                                                    style: {
                                                        marginTop: 8
                                                    },
                                                    children: "".concat(formatPrice(plan.price, currency), "/mth")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: (subscriptions_module_default()).planFeatures,
                                            style: {
                                                listStyle: "none",
                                                padding: 0,
                                                margin: 0,
                                                borderTop: "none"
                                            },
                                            children: plan.features.map(function(feature, idx) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 12
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                display: "inline-flex",
                                                                flexShrink: 0
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {
                                                                size: 20
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                            variant: "text-md",
                                                            color: "grayDark-300",
                                                            style: {
                                                                flex: 1
                                                            },
                                                            children: feature
                                                        })
                                                    ]
                                                }, idx);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (subscriptions_module_default()).planCta,
                                            style: {
                                                borderTop: "1px solid var(--color-gray-dark-700)",
                                                marginTop: 24,
                                                marginLeft: -32,
                                                marginRight: -32,
                                                marginBottom: -32,
                                                padding: "24px 32px",
                                                background: "rgba(255, 255, 255, 0.03)",
                                                borderBottomLeftRadius: 16,
                                                borderBottomRightRadius: 16
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                                                    variant: "primary",
                                                    onClick: function() {
                                                        if (plan._id) {
                                                            handleSelectCard(plan._id);
                                                        }
                                                    },
                                                    fullWidth: true,
                                                    children: "Get started"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }, plan._id || "plan-".concat(index));
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bookpage_SubscriptionModal, {
                isOpen: modalOpen,
                onClose: function() {
                    setModalOpen(false);
                    setModalSelectedPlanId(null);
                },
                topOffset: isMobile ? 56 : 72,
                productId: productId,
                selectedPlanId: modalSelectedPlanId
            })
        ]
    });
};
/* harmony default export */ var bookpage_Subscriptions = (Subscriptions);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
;// CONCATENATED MODULE: ./components/bookpage/BinaryModal.tsx
/* provided dependency */ var BinaryModal_process = __webpack_require__(82985);
















// Map app name to icon path (aligned with BookPageHome.tsx 243-295)
var BinaryModal_getIconSrcForApp = function(app) {
    var iconSrc = "";
    switch(app){
        case "DaVinci Resolve":
            iconSrc = "/logo/DaVinci_Resolve_Studio.svg";
            break;
        case "Adobe Premiere Pro":
            iconSrc = "/logo/Adobe_Premiere_Pro.svg";
            break;
        case "Sony VEGAS Pro":
            iconSrc = "/logo/Vegas_Pro.svg";
            break;
        case "Final Cut Pro":
            iconSrc = "/logo/Final_Cut_Pro.svg";
            break;
        case "Natron":
            iconSrc = "/logo/Natron.svg";
            break;
        case "Nuke":
            iconSrc = "/logo/Nuke.svg";
            break;
        case "Apple Motion":
            iconSrc = "/logo/Apple_Motion.svg";
            break;
        default:
            iconSrc = "";
    }
    return iconSrc;
};
var BinaryModal_API_BASE_URL = BinaryModal_process.env.NEXT_PUBLIC_API_BASE_URL || "https://api.vxfx.io" || 0;
function fetchPrice(path, productId, signal) {
    return _fetchPrice.apply(this, arguments);
}
function _fetchPrice() {
    _fetchPrice = (0,_async_to_generator/* default */.Z)(function(path, productId, signal) {
        var url, res, errorText, json;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "".concat(BinaryModal_API_BASE_URL, "/price-ops/").concat(path, "/").concat(productId);
                    return [
                        4,
                        fetch(url, {
                            signal: signal
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!!res.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        res.text().catch(function() {
                            return "";
                        })
                    ];
                case 2:
                    errorText = _state.sent();
                    throw new Error("Failed to fetch ".concat(path, ": ").concat(res.status, " ").concat(errorText));
                case 3:
                    return [
                        4,
                        res.json()
                    ];
                case 4:
                    json = _state.sent();
                    if (!(json === null || json === void 0 ? void 0 : json.data)) {
                        throw new Error("Invalid ".concat(path, " response"));
                    }
                    return [
                        2,
                        json.data
                    ];
            }
        });
    });
    return _fetchPrice.apply(this, arguments);
}
var BinaryModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, topOffset = param.topOffset, productId = param.productId, selectedPackage = param.selectedPackage;
    var ref = (0,react.useState)(1), currentStep = ref[0], setCurrentStep = ref[1];
    var ref1 = (0,react.useState)([]), selectedIds = ref1[0], setSelectedIds = ref1[1];
    var ref2 = (0,react.useState)(null), basePrice = ref2[0], setBasePrice = ref2[1];
    var ref3 = (0,react.useState)(null), perHostPrice = ref3[0], setPerHostPrice = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(null), error = ref5[0], setError = ref5[1];
    var ref6 = (0,react.useState)(false), purchaseLoading = ref6[0], setPurchaseLoading = ref6[1];
    var ref7 = (0,react.useState)([]), hosts = ref7[0], setHosts = ref7[1];
    var ref8 = (0,react.useState)(false), hostsLoading = ref8[0], setHostsLoading = ref8[1];
    var toastIdsRef = (0,react.useRef)([]);
    var ref9 = (0,react.useState)("0"), additionalHosts = ref9[0], setAdditionalHosts = ref9[1];
    var ref10 = (0,react.useState)("0"), additionalHardware = ref10[0], setAdditionalHardware = ref10[1];
    var previousStepRef = (0,react.useRef)(1);
    var ref11 = (0,react.useState)(null), promotion = ref11[0], setPromotion = ref11[1];
    var ref12 = (0,react.useState)(null), product = ref12[0], setProduct = ref12[1];
    var ref13 = (0,react.useState)(false), productLoading = ref13[0], setProductLoading = ref13[1];
    // Default values - no UI selection needed
    var currency = "eur";
    // Convert hosts from API to HostOption format (flatten OFX subItems)
    var hostOptions = (0,react.useMemo)(function() {
        var options = [];
        hosts.forEach(function(host) {
            options.push({
                id: host._id,
                name: host.name,
                displayName: host.displayName,
                icon: BinaryModal_getIconSrcForApp(host.displayName)
            });
        });
        // remove duplicates
        options = options.filter(function(option, index, self) {
            return index === self.findIndex(function(t) {
                return t.id === option.id;
            });
        });
        return options;
    }, [
        hosts
    ]);
    // Reset flow when modal closes or package changes
    (0,react.useEffect)(function() {
        if (!isOpen) {
            setCurrentStep(1);
            setHosts([]);
            setSelectedIds([]);
            setError(null);
            setPurchaseLoading(false);
            setAdditionalHosts("0");
            setAdditionalHardware("0");
            setPromotion(null);
            setProduct(null);
            previousStepRef.current = 1;
            // Clear toast IDs ref
            toastIdsRef.current = [];
        }
    }, [
        isOpen
    ]);
    // Reset to step 1 when package changes
    (0,react.useEffect)(function() {
        if (selectedPackage) {
            setCurrentStep(1);
            setAdditionalHosts("0");
            setAdditionalHardware("0");
            previousStepRef.current = 1;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedPackage === null || selectedPackage === void 0 ? void 0 : selectedPackage._id
    ]);
    var loadPrices = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ac, ref, base, perHost, e, errorMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!productId) {
                            return [
                                2
                            ];
                        }
                        setLoading(true);
                        setError(null);
                        ac = new AbortController();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            Promise.all([
                                fetchPrice("base", productId, ac.signal),
                                fetchPrice("per-host", productId, ac.signal)
                            ])
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), base = ref[0], perHost = ref[1];
                        setBasePrice(base);
                        setPerHostPrice(perHost);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        errorMessage = (e === null || e === void 0 ? void 0 : e.message) || "Error loading prices. Please try again.";
                        setError(errorMessage);
                        react_hot_toast_dist/* default.error */.ZP.error(errorMessage);
                        setBasePrice(null);
                        setPerHostPrice(null);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadPrices() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadHosts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, token, response, hosts, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, host, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, subItem, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, hostItem, e, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!productId) {
                            return [
                                2
                            ];
                        }
                        setHostsLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios/* default.get */.Z.get("".concat(BinaryModal_API_BASE_URL, "/host?product=").concat(productId), {
                                headers: {
                                    Authorization: token ? "".concat(token) : "",
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if ((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.success) && (response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.data)) {
                            hosts = [];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = response.data.data[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    host = _step.value;
                                    if (host.subItems) {
                                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(_iterator1 = Object.keys(host.subItems)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                subItem = _step1.value;
                                                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                                try {
                                                    for(_iterator2 = host.subItems[subItem][Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                        hostItem = _step2.value;
                                                        hosts.push({
                                                            _id: hostItem,
                                                            name: hostItem,
                                                            displayName: hostItem
                                                        });
                                                    }
                                                } catch (err) {
                                                    _didIteratorError2 = true;
                                                    _iteratorError2 = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                            _iterator2.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError2) {
                                                            throw _iteratorError2;
                                                        }
                                                    }
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                    } else {
                                        hosts.push(host);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            setHosts(hosts);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        console.error("Error loading hosts:", e);
                        // Don't set the blocking error state here, as we can still work without OS filtering,
                        // but still let the user know the host list failed to load.
                        react_hot_toast_dist/* default.error */.ZP.error((e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || "Failed to load available hosts. Please try again.");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setHostsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadHosts() {
            return _ref.apply(this, arguments);
        };
    }();
    // Load hosts when modal opens (needed for Step 1 max limit and Step 2 selection)
    (0,react.useEffect)(function() {
        if (isOpen && productId) {
            loadHosts();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        productId
    ]);
    // Fetch product data
    (0,react.useEffect)(function() {
        if (!productId || !isOpen) return;
        var mounted = true;
        var fetchProduct = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var productData, ref, response, apiError, ref1, response1, actualProduct, e, ref2, ref3;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setProductLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                7,
                                8,
                                9
                            ]);
                            productData = null;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                6
                            ]);
                            return [
                                4,
                                axios/* default.get */.Z.get("".concat(BinaryModal_API_BASE_URL, "/products/").concat(productId))
                            ];
                        case 3:
                            response = _state.sent();
                            if ((ref = response.data) === null || ref === void 0 ? void 0 : ref.data) {
                                productData = response.data.data;
                            } else if (response.data && !response.data.data) {
                                // Response might be direct product object
                                productData = response.data;
                            }
                            return [
                                3,
                                6
                            ];
                        case 4:
                            apiError = _state.sent();
                            return [
                                4,
                                axios/* default.get */.Z.get("".concat(BinaryModal_API_BASE_URL, "/product-details/").concat(productId))
                            ];
                        case 5:
                            response1 = _state.sent();
                            if ((ref1 = response1.data) === null || ref1 === void 0 ? void 0 : ref1.data) {
                                productData = response1.data.data;
                            }
                            return [
                                3,
                                6
                            ];
                        case 6:
                            if (!mounted) return [
                                2
                            ];
                            if (productData) {
                                actualProduct = null;
                                if (Array.isArray(productData)) {
                                    // If it's an array, take the first element
                                    actualProduct = productData[0];
                                } else if (productData.product) {
                                    // If it has nested product property
                                    actualProduct = productData.product;
                                } else {
                                    // Direct product object
                                    actualProduct = productData;
                                }
                                setProduct(actualProduct);
                            }
                            return [
                                3,
                                9
                            ];
                        case 7:
                            e = _state.sent();
                            if (!mounted) return [
                                2
                            ];
                            console.error("Error fetching product:", e);
                            setProduct(null);
                            react_hot_toast_dist/* default.error */.ZP.error((e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || "Failed to load pricing details. Please try again.");
                            return [
                                3,
                                9
                            ];
                        case 8:
                            if (mounted) {
                                setProductLoading(false);
                            }
                            return [
                                7
                            ];
                        case 9:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchProduct() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchProduct();
        return function() {
            mounted = false;
        };
    }, [
        productId,
        isOpen
    ]);
    // Fetch promotion for product
    (0,react.useEffect)(function() {
        if (!productId || !isOpen) return;
        var mounted = true;
        var fetchPromotion = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, response, promotionData, e, ref1, ref2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                axios/* default.get */.Z.get("".concat(BinaryModal_API_BASE_URL, "/promotions/product/").concat(productId, "/active"))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!mounted) return [
                                2
                            ];
                            promotionData = ((ref = response.data) === null || ref === void 0 ? void 0 : ref.data) !== undefined ? response.data.data : response.data;
                            // If response is null or empty, no active promotion
                            if (!promotionData) {
                                setPromotion(null);
                            } else if (promotionData.isActive) {
                                setPromotion(promotionData);
                            } else {
                                setPromotion(null);
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            if (!mounted) return [
                                2
                            ];
                            // If 404 or no active promotion, set to null (not an error)
                            if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 404 || (e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 400) {
                                setPromotion(null);
                            } else {
                                console.error("Error fetching promotion:", e);
                                setPromotion(null);
                            }
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPromotion() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPromotion();
        return function() {
            mounted = false;
        };
    }, [
        productId,
        isOpen
    ]);
    // Limit additionalHosts when hosts are loaded (use unique hosts count from hostOptions minus package hostLimit)
    (0,react.useEffect)(function() {
        if (hostOptions.length > 0 && additionalHosts && selectedPackage) {
            var currentValue = parseInt(additionalHosts);
            var maxAdditionalHosts = Math.max(0, hostOptions.length - selectedPackage.hostLimit);
            if (!isNaN(currentValue) && currentValue > maxAdditionalHosts) {
                setAdditionalHosts(maxAdditionalHosts.toString());
            }
        }
    }, [
        hostOptions.length,
        additionalHosts,
        selectedPackage
    ]);
    // Clear selected hosts when going back to step 1
    (0,react.useEffect)(function() {
        // If we're going back to step 1 from step 2, clear selections
        var prevStep = previousStepRef.current;
        if (currentStep === 1 && prevStep === 2 && selectedIds.length > 0) {
            setSelectedIds([]);
        }
        // Update previous step ref after checking
        previousStepRef.current = currentStep;
    }, [
        currentStep,
        selectedIds.length
    ]);
    // Clear selections when package or additional hosts count changes
    (0,react.useEffect)(function() {
        if (selectedIds.length > 0) {
            setSelectedIds([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedPackage === null || selectedPackage === void 0 ? void 0 : selectedPackage._id,
        additionalHosts
    ]);
    var toggleSelection = function(id, maxAllowed) {
        setSelectedIds(function(prev) {
            if (prev.includes(id)) {
                // Allow deselection
                return prev.filter(function(x) {
                    return x !== id;
                });
            } else {
                // Only allow selection if under the limit
                if (prev.length < maxAllowed) {
                    return (0,_to_consumable_array/* default */.Z)(prev).concat([
                        id
                    ]);
                }
                return prev;
            }
        });
    };
    // Create order and redirect to Stripe from Step 1
    var handlePurchaseFromStep1 = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, token, selectedHostNames, additionalHostsCount, maxAdditionalHosts, allHostsIncluded, additionalHostsCountFinal, additionalHardwareCountFinal, requestBody, orderEndpoint, response, ref5, error, ref6, ref7, errorMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!selectedPackage) return [
                            2
                        ];
                        setPurchaseLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        token = localStorage.getItem("auth-token");
                        if (!token) {
                            localStorage.setItem("redirectTo", window.location.pathname + window.location.search);
                            onClose();
                            window.location.href = "/login";
                            return [
                                2
                            ];
                        }
                        selectedHostNames = [];
                        additionalHostsCount = parseInt(additionalHosts) || 0;
                        maxAdditionalHosts = Math.max(0, hostOptions.length - selectedPackage.hostLimit);
                        allHostsIncluded = hostOptions.length > 0 && hostOptions.length === selectedPackage.hostLimit;
                        if (allHostsIncluded || additionalHostsCount === maxAdditionalHosts && maxAdditionalHosts > 0) {
                            // If all hosts are included in package or user selected maximum additional hosts, send all host names
                            selectedHostNames = hostOptions.map(function(option) {
                                return option.name;
                            });
                        }
                        additionalHostsCountFinal = parseInt(additionalHosts) || 0;
                        additionalHardwareCountFinal = parseInt(additionalHardware) || 0;
                        requestBody = {
                            packageId: selectedPackage._id,
                            currency: currency,
                            supports: selectedHostNames,
                            additionalHosts: additionalHostsCountFinal,
                            additionalHardware: additionalHardwareCountFinal
                        };
                        // Add promotionId if promotion is active
                        if (promotion && promotion.isActive && promotion._id) {
                            requestBody.promotionId = promotion._id;
                        }
                        orderEndpoint = promotion && promotion.isActive ? "".concat(BinaryModal_API_BASE_URL, "/order/preorder") : "".concat(BinaryModal_API_BASE_URL, "/order");
                        return [
                            4,
                            axios/* default.post */.Z.post(orderEndpoint, requestBody, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.success) && ((ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.session) === null || ref2 === void 0 ? void 0 : ref2.url)) {
                            // Redirect to Stripe checkout
                            window.location.href = response.data.session.url;
                        } else if (((ref3 = response.data) === null || ref3 === void 0 ? void 0 : ref3.success) && ((ref4 = response.data) === null || ref4 === void 0 ? void 0 : ref4.order)) {
                            // Free order: completed immediately, no Stripe redirect needed.
                            // window.location.href is a hard navigation that tears down the JS
                            // runtime, so the toast is queued in sessionStorage and flushed by
                            // <ToastProvider/> once the destination page mounts.
                            (0,ToastProvider/* queueToast */.Q5)("success", "Order placed! We've emailed your confirmation — redirecting you to My Orders.");
                            window.location.href = "/members-area?tab=myorders";
                        } else {
                            ;
                            throw new Error(((ref5 = response.data) === null || ref5 === void 0 ? void 0 : ref5.message) || "Failed to create order");
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error creating order:", error);
                        errorMessage = ((ref6 = error.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.message) || error.message || "Something went wrong while creating your order. Please try again.";
                        react_hot_toast_dist/* default.error */.ZP.error(errorMessage);
                        setError(errorMessage);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setPurchaseLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePurchaseFromStep1() {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePurchase = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, token, selectedHostNames, additionalHostsCountFinal, additionalHardwareCountFinal, requestBody, orderEndpoint, response, ref5, error, ref6, ref7, errorMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Validation
                        if (selectedIds.length === 0) {
                            react_hot_toast_dist/* default.error */.ZP.error("Please select at least one host.");
                            return [
                                2
                            ];
                        }
                        if (!selectedPackage) {
                            react_hot_toast_dist/* default.error */.ZP.error("Please select a package to continue.");
                            return [
                                2
                            ];
                        }
                        setPurchaseLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        token = localStorage.getItem("auth-token");
                        if (!token) {
                            localStorage.setItem("redirectTo", window.location.pathname + window.location.search);
                            onClose();
                            window.location.href = "/login";
                            return [
                                2
                            ];
                        }
                        selectedHostNames = selectedIds.map(function(id) {
                            // If ID contains '-', it's a subItem (format: "hostId-subItem")
                            var parts = id.split("-");
                            if (parts.length > 1) {
                                // For subItems, use the subItem name (the part after first '-')
                                return parts.slice(1).join("-");
                            } else {
                                // For regular hosts, find by _id and get name
                                var host = hosts.find(function(h) {
                                    return h._id === id;
                                });
                                return host === null || host === void 0 ? void 0 : host.name;
                            }
                        }).filter(function(name) {
                            return !!name;
                        });
                        additionalHostsCountFinal = parseInt(additionalHosts) || 0;
                        additionalHardwareCountFinal = parseInt(additionalHardware) || 0;
                        requestBody = {
                            packageId: selectedPackage._id,
                            currency: currency,
                            supports: selectedHostNames,
                            additionalHosts: additionalHostsCountFinal,
                            additionalHardware: additionalHardwareCountFinal
                        };
                        // Add promotionId if promotion is active
                        if (promotion && promotion.isActive && promotion._id) {
                            requestBody.promotionId = promotion._id;
                        }
                        orderEndpoint = promotion && promotion.isActive ? "".concat(BinaryModal_API_BASE_URL, "/order/preorder") : "".concat(BinaryModal_API_BASE_URL, "/order");
                        return [
                            4,
                            axios/* default.post */.Z.post(orderEndpoint, requestBody, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.success) && ((ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.session) === null || ref2 === void 0 ? void 0 : ref2.url)) {
                            // Redirect to Stripe checkout
                            window.location.href = response.data.session.url;
                        } else if (((ref3 = response.data) === null || ref3 === void 0 ? void 0 : ref3.success) && ((ref4 = response.data) === null || ref4 === void 0 ? void 0 : ref4.order)) {
                            // Free order: completed immediately, no Stripe redirect needed.
                            // window.location.href is a hard navigation that tears down the JS
                            // runtime, so the toast is queued in sessionStorage and flushed by
                            // <ToastProvider/> once the destination page mounts.
                            (0,ToastProvider/* queueToast */.Q5)("success", "Order placed! We've emailed your confirmation — redirecting you to My Orders.");
                            window.location.href = "/members-area?tab=myorders";
                        } else {
                            ;
                            throw new Error(((ref5 = response.data) === null || ref5 === void 0 ? void 0 : ref5.message) || "Failed to create order");
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error creating order:", error);
                        errorMessage = ((ref6 = error.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.message) || error.message || "Something went wrong while creating your order. Please try again.";
                        react_hot_toast_dist/* default.error */.ZP.error(errorMessage);
                        setError(errorMessage);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setPurchaseLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePurchase() {
            return _ref.apply(this, arguments);
        };
    }();
    // Find the highest step that still has available slots
    var getActiveStep = function(promotion) {
        if (!promotion || !promotion.steps || promotion.steps.length === 0) {
            return null;
        }
        // Sort steps by discountPercentage descending to find the highest available step
        var sortedSteps = (0,_to_consumable_array/* default */.Z)(promotion.steps).sort(function(a, b) {
            return b.discountPercentage - a.discountPercentage;
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Find the first step that still has available slots
            for(var _iterator = sortedSteps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var step = _step.value;
                var usedOrders = step.usedOrders || 0;
                if (usedOrders < step.maxOrders) {
                    return step;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    // Calculate Step 1 pricing
    var step1Pricing = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        if (!selectedPackage) return null;
        var basePackageOldPrice = selectedPackage.price[currency];
        var basePackageCurrentPrice = selectedPackage.price[currency];
        var additionalHostsCount = additionalHosts ? parseInt(additionalHosts, 10) || 0 : 0;
        var additionalHardwareCount = additionalHardware ? parseInt(additionalHardware, 10) || 0 : 0;
        var ref12, ref13, ref14, ref15;
        // Prices per unit (from product API)
        // Check both product.additionalHostPrice and product.product.additionalHostPrice
        var perHostPriceValue = (ref15 = (ref14 = (ref13 = (ref12 = product === null || product === void 0 ? void 0 : (ref = product.additionalHostPrice) === null || ref === void 0 ? void 0 : ref[currency]) !== null && ref12 !== void 0 ? ref12 : product === null || product === void 0 ? void 0 : (ref1 = product.additionalHostPrice) === null || ref1 === void 0 ? void 0 : ref1.eur) !== null && ref13 !== void 0 ? ref13 : product === null || product === void 0 ? void 0 : (ref2 = product.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.additionalHostPrice) === null || ref3 === void 0 ? void 0 : ref3[currency]) !== null && ref14 !== void 0 ? ref14 : product === null || product === void 0 ? void 0 : (ref4 = product.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.additionalHostPrice) === null || ref5 === void 0 ? void 0 : ref5.eur) !== null && ref15 !== void 0 ? ref15 : 0;
        var ref16, ref17, ref18, ref19;
        var perHardwarePriceValue = (ref19 = (ref18 = (ref17 = (ref16 = product === null || product === void 0 ? void 0 : (ref6 = product.additionalHardwarePrice) === null || ref6 === void 0 ? void 0 : ref6[currency]) !== null && ref16 !== void 0 ? ref16 : product === null || product === void 0 ? void 0 : (ref7 = product.additionalHardwarePrice) === null || ref7 === void 0 ? void 0 : ref7.eur) !== null && ref17 !== void 0 ? ref17 : product === null || product === void 0 ? void 0 : (ref8 = product.product) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.additionalHardwarePrice) === null || ref9 === void 0 ? void 0 : ref9[currency]) !== null && ref18 !== void 0 ? ref18 : product === null || product === void 0 ? void 0 : (ref10 = product.product) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.additionalHardwarePrice) === null || ref11 === void 0 ? void 0 : ref11.eur) !== null && ref19 !== void 0 ? ref19 : 0;
        // Calculate base costs (before discount)
        var additionalHostsCostOld = additionalHostsCount * perHostPriceValue;
        var additionalHardwareCostOld = additionalHardwareCount * perHardwarePriceValue;
        // Calculate total base price (package + hosts + hardware)
        var totalBasePrice = basePackageOldPrice + additionalHostsCostOld + additionalHardwareCostOld;
        // Get active step and apply discount if promotion is active
        var activeStep = getActiveStep(promotion);
        var discountPercentage = 0;
        if (promotion && promotion.isActive && activeStep) {
            discountPercentage = activeStep.discountPercentage;
        }
        var discountAmount = totalBasePrice * discountPercentage / 100;
        var totalFinalPrice = totalBasePrice - discountAmount;
        // Calculate discounted prices for each item proportionally
        // Distribute discount proportionally based on each item's share of total
        var basePackageFinalPrice = totalBasePrice > 0 ? basePackageOldPrice - basePackageOldPrice / totalBasePrice * discountAmount : basePackageOldPrice;
        var additionalHostsCostFinal = totalBasePrice > 0 ? additionalHostsCostOld - additionalHostsCostOld / totalBasePrice * discountAmount : additionalHostsCostOld;
        var additionalHardwareCostFinal = totalBasePrice > 0 ? additionalHardwareCostOld - additionalHardwareCostOld / totalBasePrice * discountAmount : additionalHardwareCostOld;
        return {
            basePackage: {
                oldPrice: basePackageOldPrice,
                currentPrice: discountPercentage > 0 ? basePackageFinalPrice : basePackageCurrentPrice
            },
            additionalHosts: {
                oldPrice: additionalHostsCostOld,
                currentPrice: discountPercentage > 0 ? additionalHostsCostFinal : additionalHostsCostOld
            },
            additionalHardware: {
                oldPrice: additionalHardwareCostOld,
                currentPrice: discountPercentage > 0 ? additionalHardwareCostFinal : additionalHardwareCostOld
            },
            perHostPrice: perHostPriceValue,
            perHardwarePrice: perHardwarePriceValue,
            total: {
                oldPrice: totalBasePrice,
                currentPrice: totalFinalPrice
            },
            hasDiscount: discountPercentage > 0
        };
    }, [
        selectedPackage,
        additionalHosts,
        additionalHardware,
        product,
        currency,
        promotion
    ]);
    // Tooltip icon component for inputs
    var HelpTooltipIcon = function(param) {
        var title = param.title;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
            title: title,
            placement: "top",
            overlayInnerStyle: {
                backgroundColor: "#2a2a2a",
                maxWidth: "300px",
                zIndex: 10002
            },
            getPopupContainer: function() {
                return document.body;
            },
            overlayClassName: (binary_module_default()).tooltipOverlay,
            zIndex: 10002,
            destroyTooltipOnHide: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "absolute",
                    right: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    color: "var(--color-gray-dark-500)",
                    pointerEvents: "auto",
                    zIndex: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/help.svg",
                    alt: "Help",
                    width: "16",
                    height: "16"
                })
            })
        });
    };
    // Step 1: Package customization (Figma design)
    var renderStep1 = function() {
        var ref, ref1;
        if (!selectedPackage) return null;
        var pricing = step1Pricing;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (binary_module_default()).step1Content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (binary_module_default()).selectedPackageCard,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (binary_module_default()).selectedPackageIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/packageIllustration.svg",
                                alt: "Package"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).selectedPackageText,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (binary_module_default()).selectedPackageTitleRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "grayDark-300",
                                            weight: "medium",
                                            children: "Selected package:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "grayDark-400",
                                            children: selectedPackage.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    style: {
                                        marginTop: 4
                                    },
                                    children: [
                                        "Base configuration includes: ",
                                        selectedPackage.hostLimit,
                                        " supported hosts,",
                                        " ",
                                        selectedPackage.hardwareLimit,
                                        " development machines"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (binary_module_default()).additionalOptions,
                    children: [
                        function() {
                            var ref;
                            var maxAdditionalHosts = Math.max(0, hostOptions.length - selectedPackage.hostLimit);
                            // Don't show input if user can't select additional hosts
                            if (maxAdditionalHosts === 0) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (binary_module_default()).optionField,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        color: "grayDark-300",
                                        weight: "medium",
                                        children: "Number of additional hosts"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                        placeholder: "Enter number of additional hosts",
                                        value: additionalHosts,
                                        onChange: function(e) {
                                            var value = e.target.value.replace(/[^0-9]/g, "");
                                            if (value === "") {
                                                setAdditionalHosts("");
                                            } else {
                                                var numValue = parseInt(value);
                                                if (!isNaN(numValue)) {
                                                    if (maxAdditionalHosts > 0 && numValue > maxAdditionalHosts) {
                                                        setAdditionalHosts(maxAdditionalHosts.toString());
                                                    } else {
                                                        setAdditionalHosts(value);
                                                    }
                                                }
                                            }
                                        },
                                        fullWidth: true,
                                        type: "number",
                                        max: maxAdditionalHosts > 0 ? maxAdditionalHosts : undefined,
                                        helperText: maxAdditionalHosts > 0 && pricing ? "Maximum ".concat(maxAdditionalHosts, " additional hosts available (€").concat(productLoading ? "..." : pricing.perHostPrice.toLocaleString(), " per host)") : undefined,
                                        rightElement: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpTooltipIcon, {
                                            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                        variant: "text-sm",
                                                        color: "grayDark-50",
                                                        weight: "semibold",
                                                        children: "Additional Hosts"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                        variant: "text-sm",
                                                        color: "grayDark-400",
                                                        style: {
                                                            marginTop: 8
                                                        },
                                                        children: [
                                                            "Enter the number of additional hosts you need beyond the base package configuration. Each additional host costs €",
                                                            productLoading ? "..." : (pricing === null || pricing === void 0 ? void 0 : (ref = pricing.perHostPrice) === null || ref === void 0 ? void 0 : ref.toLocaleString()) || "0",
                                                            " ",
                                                            "per year.",
                                                            maxAdditionalHosts > 0 && " Maximum: ".concat(maxAdditionalHosts, " additional hosts.")
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            });
                        }(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).optionField,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-300",
                                    weight: "medium",
                                    children: "Number of additional development machines"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                    placeholder: "Enter number of additional development machines",
                                    value: additionalHardware,
                                    onChange: function(e) {
                                        var value = e.target.value.replace(/[^0-9]/g, "");
                                        setAdditionalHardware(value);
                                    },
                                    fullWidth: true,
                                    type: "number",
                                    rightElement: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpTooltipIcon, {
                                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                    variant: "text-sm",
                                                    color: "grayDark-50",
                                                    weight: "semibold",
                                                    children: "Additional Development Machines"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                    variant: "text-sm",
                                                    color: "grayDark-400",
                                                    style: {
                                                        marginTop: 8
                                                    },
                                                    children: [
                                                        "Enter the number of additional development machines you need beyond the base package configuration. Each additional development machine costs €",
                                                        productLoading ? "..." : (pricing === null || pricing === void 0 ? void 0 : (ref = pricing.perHardwarePrice) === null || ref === void 0 ? void 0 : ref.toLocaleString()) || "0",
                                                        " ",
                                                        "per year."
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    style: {
                                        marginTop: 8
                                    },
                                    children: [
                                        "€",
                                        productLoading ? "..." : (pricing === null || pricing === void 0 ? void 0 : (ref1 = pricing.perHardwarePrice) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString()) || "0",
                                        " per development machine"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                pricing && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (binary_module_default()).priceSummary,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                            variant: "text-md",
                            color: "grayDark-50",
                            weight: "semibold",
                            style: {
                                marginBottom: 16
                            },
                            children: "Price Summary"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).priceRow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    children: "Base Package"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (binary_module_default()).priceValues,
                                    children: [
                                        pricing.hasDiscount && pricing.basePackage.oldPrice > pricing.basePackage.currentPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "error",
                                            style: {
                                                textDecoration: "line-through",
                                                marginRight: 8
                                            },
                                            children: [
                                                "€",
                                                Math.round(pricing.basePackage.oldPrice).toLocaleString()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "grayDark-50",
                                            weight: "semibold",
                                            children: [
                                                "€",
                                                Math.round(pricing.basePackage.currentPrice).toLocaleString()
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        function() {
                            var maxAdditionalHosts = Math.max(0, hostOptions.length - selectedPackage.hostLimit);
                            // Don't show price row if user can't select additional hosts
                            if (maxAdditionalHosts === 0) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (binary_module_default()).priceRow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        color: "grayDark-400",
                                        children: [
                                            "Additional supported hosts (€",
                                            productLoading ? "..." : pricing.perHostPrice.toLocaleString(),
                                            " per host)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (binary_module_default()).priceValues,
                                        children: [
                                            pricing.hasDiscount && pricing.additionalHosts.oldPrice > 0 && pricing.additionalHosts.oldPrice > pricing.additionalHosts.currentPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                variant: "text-sm",
                                                color: "error",
                                                style: {
                                                    textDecoration: "line-through",
                                                    marginRight: 8
                                                },
                                                children: [
                                                    "€",
                                                    Math.round(pricing.additionalHosts.oldPrice).toLocaleString()
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                variant: "text-sm",
                                                color: "grayDark-50",
                                                weight: "semibold",
                                                children: [
                                                    "€",
                                                    Math.round(pricing.additionalHosts.currentPrice).toLocaleString()
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            });
                        }(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).priceRow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    children: [
                                        "Additional development machines (€",
                                        productLoading ? "..." : pricing.perHardwarePrice.toLocaleString(),
                                        " per development machine)"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (binary_module_default()).priceValues,
                                    children: [
                                        pricing.hasDiscount && pricing.additionalHardware.oldPrice > 0 && pricing.additionalHardware.oldPrice > pricing.additionalHardware.currentPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "error",
                                            style: {
                                                textDecoration: "line-through",
                                                marginRight: 8
                                            },
                                            children: [
                                                "€",
                                                Math.round(pricing.additionalHardware.oldPrice).toLocaleString()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "grayDark-50",
                                            weight: "semibold",
                                            children: [
                                                "€",
                                                Math.round(pricing.additionalHardware.currentPrice).toLocaleString()
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).priceRowTotal,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-md",
                                    color: "grayDark-50",
                                    weight: "semibold",
                                    children: "Total price"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (binary_module_default()).priceValues,
                                    children: [
                                        pricing.hasDiscount && pricing.total.oldPrice > pricing.total.currentPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "error",
                                            style: {
                                                textDecoration: "line-through",
                                                marginRight: 8
                                            },
                                            children: [
                                                "€",
                                                Math.round(pricing.total.oldPrice).toLocaleString()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                            variant: "text-md",
                                            color: pricing.hasDiscount ? "success" : "grayDark-50",
                                            weight: "semibold",
                                            children: [
                                                "€",
                                                Math.round(pricing.total.currentPrice).toLocaleString()
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    // Step 2: Host selection (current content)
    var renderStep2 = function() {
        // Calculate max allowed selections: package hostLimit + additional hosts
        var packageHostLimit = (selectedPackage === null || selectedPackage === void 0 ? void 0 : selectedPackage.hostLimit) || 0;
        var additionalHostsCount = parseInt(additionalHosts) || 0;
        var maxAllowedSelections = packageHostLimit + additionalHostsCount;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: purchaseLoading ? (binary_module_default()).contentDisabled : "",
            "aria-disabled": purchaseLoading,
            children: [
                error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginBottom: 12,
                        color: "#ff6961"
                    },
                    children: error
                }) : null,
                maxAllowedSelections > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                    variant: "text-sm",
                    color: "grayDark-400",
                    style: {
                        marginBottom: 16
                    },
                    children: [
                        "Select up to ",
                        maxAllowedSelections,
                        " host",
                        maxAllowedSelections !== 1 ? "s" : "",
                        " (",
                        selectedIds.length,
                        "/",
                        maxAllowedSelections,
                        " selected)"
                    ]
                }),
                hostsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (binary_module_default()).grid,
                    children: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6
                    ].map(function(index) {
                        // Vary text width for more natural look
                        var widths = [
                            150,
                            180,
                            140,
                            160,
                            170,
                            155
                        ];
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (binary_module_default()).hostSkeletonCard,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (binary_module_default()).hostSkeletonLeft,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (binary_module_default()).hostSkeletonIcon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (binary_module_default()).hostSkeletonText,
                                            style: {
                                                width: "".concat(widths[index - 1], "px")
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (binary_module_default()).hostSkeletonCheck
                                })
                            ]
                        }, index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (binary_module_default()).grid,
                    children: hostOptions.map(function(host) {
                        var selected = selectedIds.includes(host.id);
                        var isDisabled = !selected && selectedIds.length >= maxAllowedSelections;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "".concat((binary_module_default()).hostCard, " ").concat(selected ? (binary_module_default()).selected : "", " ").concat(isDisabled ? (binary_module_default()).disabled : ""),
                            onClick: function() {
                                return toggleSelection(host.id, maxAllowedSelections);
                            },
                            "aria-pressed": selected,
                            disabled: purchaseLoading || isDisabled,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (binary_module_default()).hostLeft,
                                    children: [
                                        host.icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: host.icon,
                                            alt: "",
                                            "aria-hidden": "true",
                                            style: {
                                                width: "32px",
                                                height: "32px"
                                            }
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                            variant: "text-lg",
                                            color: "grayDark-50",
                                            weight: "medium",
                                            children: host.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (binary_module_default()).check
                                })
                            ]
                        }, host.id);
                    })
                })
            ]
        });
    };
    // Get title based on current step
    var getModalTitle = function() {
        if (currentStep === 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 12,
                        position: "relative",
                        zIndex: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                position: "relative",
                                width: 48,
                                height: 48,
                                flexShrink: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/modal-background-pattern.svg",
                                    alt: "",
                                    "aria-hidden": "true",
                                    style: {
                                        position: "absolute",
                                        top: -24,
                                        left: -24,
                                        width: 216,
                                        height: 217,
                                        opacity: 0.9,
                                        pointerEvents: "none",
                                        zIndex: 0
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/customIllustration.svg",
                                    alt: "Customize"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                zIndex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-lg",
                                    color: "grayDark-50",
                                    weight: "semibold",
                                    children: "Customize your package"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    children: "Share where you've worked on your profile."
                                })
                            ]
                        })
                    ]
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 12,
                        position: "relative",
                        zIndex: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                position: "relative",
                                width: 48,
                                height: 48,
                                flexShrink: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/modal-background-pattern.svg",
                                    alt: "",
                                    "aria-hidden": "true",
                                    style: {
                                        position: "absolute",
                                        top: -24,
                                        left: -24,
                                        width: 216,
                                        height: 217,
                                        opacity: 0.9,
                                        pointerEvents: "none",
                                        zIndex: 0
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/hostIllustration.svg",
                                    alt: "Host"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                zIndex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-lg",
                                    color: "grayDark-50",
                                    weight: "semibold",
                                    children: "Select your host"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                    variant: "text-sm",
                                    color: "grayDark-400",
                                    children: "Choose your preferred host to generate a custom binary license."
                                })
                            ]
                        })
                    ]
                })
            });
        }
    };
    // Get footer based on current step
    var getModalFooter = function() {
        if (currentStep === 1) {
            var additionalHostsCount = parseInt(additionalHosts) || 0;
            var maxAdditionalHosts = selectedPackage ? Math.max(0, hostOptions.length - selectedPackage.hostLimit) : 0;
            var hasSelectedMaxHosts = additionalHostsCount === maxAdditionalHosts && maxAdditionalHosts > 0;
            // Skip step 2 if: user selected max hosts, or all hosts are included in package
            var allHostsIncluded = selectedPackage && hostOptions.length > 0 && hostOptions.length === selectedPackage.hostLimit;
            var shouldSkipStep2 = hasSelectedMaxHosts || allHostsIncluded;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (binary_module_default()).footerActions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                        variant: "secondary",
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                        variant: "primary",
                        onClick: function() {
                            if (shouldSkipStep2) {
                                handlePurchaseFromStep1();
                            } else {
                                setCurrentStep(2);
                            }
                        },
                        disabled: !selectedPackage,
                        loading: purchaseLoading,
                        children: shouldSkipStep2 ? promotion && promotion.isActive ? "Purchase ".concat(promotion.name) : "Purchase" : "Continue"
                    })
                ]
            });
        } else {
            // Calculate max allowed selections for Step 2
            var packageHostLimit = (selectedPackage === null || selectedPackage === void 0 ? void 0 : selectedPackage.hostLimit) || 0;
            var additionalHostsCount1 = parseInt(additionalHosts) || 0;
            var maxAllowedSelections = packageHostLimit + additionalHostsCount1;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (binary_module_default()).footerActions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                        variant: "secondary",
                        onClick: function() {
                            return setCurrentStep(1);
                        },
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                        variant: "primary",
                        onClick: handlePurchase,
                        disabled: selectedIds.length !== maxAllowedSelections || hostsLoading || hosts.length === 0 || purchaseLoading || maxAllowedSelections === 0,
                        loading: purchaseLoading,
                        children: promotion && promotion.isActive ? "Purchase ".concat(promotion.name) : "Purchase"
                    })
                ]
            });
        }
    };
    // Don't render if no package selected
    if (!selectedPackage && currentStep === 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hot_toast_dist/* Toaster */.x7, {
                position: "bottom-center",
                reverseOrder: false,
                containerStyle: {
                    zIndex: 10001
                },
                toastOptions: {
                    style: {
                        zIndex: 10001
                    }
                },
                gutter: 8
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                isOpen: isOpen && !!selectedPackage,
                onClose: purchaseLoading ? function() {} : onClose,
                topOffset: topOffset,
                maxWidth: 880,
                title: getModalTitle(),
                footer: getModalFooter(),
                children: currentStep === 1 ? renderStep1() : renderStep2()
            })
        ]
    });
};
/* harmony default export */ var bookpage_BinaryModal = (BinaryModal);

;// CONCATENATED MODULE: ./components/bookpage/LicensingOptions.tsx
/* provided dependency */ var LicensingOptions_process = __webpack_require__(82985);














var LicensingOptions_CircleBoltIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 48 : _size;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
                fill: "#7F56D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M24.9989 14L16.0923 24.6879C15.7435 25.1064 15.5691 25.3157 15.5665 25.4925C15.5641 25.6461 15.6326 25.7923 15.7521 25.8889C15.8896 26 16.1621 26 16.7069 26H23.9989L22.9989 34L31.9054 23.3121C32.2542 22.8936 32.4286 22.6843 32.4313 22.5075C32.4336 22.3539 32.3652 22.2077 32.2456 22.1111C32.1081 22 31.8357 22 31.2909 22H23.9989L24.9989 14Z",
                stroke: "#E9D7FE",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var LayersIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 48 : _size;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
                fill: "#7F56D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 26.4999L23.6422 31.3211C23.7734 31.3866 23.839 31.4194 23.9078 31.4324C23.9687 31.4438 24.0313 31.4438 24.0922 31.4324C24.161 31.4194 24.2266 31.3866 24.3578 31.3211L34 26.4999M14 21.4999L23.6422 16.6788C23.7734 16.6132 23.839 16.5804 23.9078 16.5675C23.9687 16.5561 24.0313 16.5561 24.0922 16.5675C24.161 16.5804 24.2266 16.6132 24.3578 16.6788L34 21.4999L24.3578 26.3211C24.2266 26.3866 24.161 26.4194 24.0922 26.4324C24.0313 26.4438 23.9687 26.4438 23.9078 26.4324C23.839 26.4194 23.7734 26.3866 23.6422 26.3211L14 21.4999Z",
                stroke: "#E9D7FE",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var ListLayersIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 48 : _size;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
                fill: "#7F56D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 23.9999L23.6422 28.8211C23.7734 28.8866 23.839 28.9194 23.9078 28.9324C23.9687 28.9438 24.0313 28.9438 24.0922 28.9324C24.161 28.9194 24.2266 28.8866 24.3578 28.8211L34 23.9999M14 28.9999L23.6422 33.8211C23.7734 33.8866 23.839 33.9194 23.9078 33.9324C23.9687 33.9438 24.0313 33.9438 24.0922 33.9324C24.161 33.9194 24.2266 33.8866 24.3578 33.8211L34 28.9999M14 18.9999L23.6422 14.1788C23.7734 14.1132 23.839 14.0804 23.9078 14.0675C23.9687 14.0561 24.0313 14.0561 24.0922 14.0675C24.161 14.0804 24.2266 14.1132 24.3578 14.1788L34 18.9999L24.3578 23.8211C24.2266 23.8866 24.161 23.9194 24.0922 23.9324C24.0313 23.9438 23.9687 23.9438 23.9078 23.9324C23.839 23.9194 23.7734 23.8866 23.6422 23.8211L14 18.9999Z",
                stroke: "#E9D7FE",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var LicensingOptions_CheckIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 24 : _size;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
                fill: "#9E77ED"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.098 7.39004L9.93797 14.3L8.03797 12.27C7.68797 11.94 7.13797 11.92 6.73797 12.2C6.34797 12.49 6.23797 13 6.47797 13.41L8.72797 17.07C8.94797 17.41 9.32797 17.62 9.75797 17.62C10.168 17.62 10.558 17.41 10.778 17.07C11.138 16.6 18.008 8.41004 18.008 8.41004C18.908 7.49004 17.818 6.68004 17.098 7.38004V7.39004Z",
                fill: "#E9D7FE"
            })
        ]
    });
};
var Card = function(param) {
    var title = param.title, points = param.points, actionText = param.actionText, onClick = param.onClick, _Icon = param.Icon, Icon = _Icon === void 0 ? LicensingOptions_CircleBoltIcon : _Icon, promotion = param.promotion, _currency = param.currency, currency = _currency === void 0 ? "eur" : _currency, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var displayTitle = promotion ? promotion.name : title;
    var displayPrice = promotion ? currency === "eur" ? "€".concat(promotion.preorderPrice[currency].toLocaleString(), " / year") : "€".concat(promotion.preorderPrice[currency].toLocaleString(), " / year") : null;
    // If promotion exists, combine description and price in points array
    var displayPoints = promotion ? displayPrice ? [
        promotion.description,
        displayPrice
    ] : [
        promotion.description
    ] : points;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.planCard,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.planHeader,
                style: {
                    alignItems: "center",
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            marginBottom: 8,
                            display: "inline-flex"
                        },
                        children: /*#__PURE__*/ _jsx(Icon, {
                            size: 48
                        })
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "display-sm",
                        color: "grayDark-50",
                        weight: "semibold",
                        children: displayTitle
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: styles.planFeatures,
                style: {
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    borderTop: "none"
                },
                children: displayPoints.map(function(p, idx) {
                    return /*#__PURE__*/ _jsxs("li", {
                        style: {
                            display: "flex",
                            alignItems: promotion ? "flex-start" : "center",
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                style: {
                                    display: "inline-flex",
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ _jsx(LicensingOptions_CheckIcon, {
                                    size: 20
                                })
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "text-md",
                                color: "grayDark-300",
                                style: {
                                    flex: 1
                                },
                                children: p
                            })
                        ]
                    }, idx);
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.planCta,
                style: {
                    borderTop: "1px solid var(--color-gray-dark-700)",
                    marginTop: 24,
                    // Figma-like bottom strip background
                    marginLeft: -32,
                    marginRight: -32,
                    marginBottom: -32,
                    padding: "24px 32px",
                    background: "rgba(255, 255, 255, 0.03)",
                    borderBottomLeftRadius: 16,
                    borderBottomRightRadius: 16
                },
                children: /*#__PURE__*/ _jsx("div", {
                    style: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ _jsx(Button, {
                        variant: "primary",
                        onClick: onClick,
                        fullWidth: true,
                        disabled: loading,
                        loading: loading,
                        children: actionText
                    })
                })
            })
        ]
    });
};
var LicensingSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (licensing_module_default()).tabs,
                style: {
                    opacity: 0.4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((licensing_module_default()).tabButton, " ").concat((licensing_module_default()).skeletonTab)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((licensing_module_default()).tabButton, " ").concat((licensing_module_default()).skeletonTab)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (licensing_module_default()).packagesTableWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (licensing_module_default()).tableSkeleton,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (licensing_module_default()).skeletonRow,
                            style: {
                                height: "60px",
                                marginBottom: "12px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (licensing_module_default()).skeletonRow,
                            style: {
                                height: "48px",
                                marginBottom: "12px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (licensing_module_default()).skeletonRow,
                            style: {
                                height: "48px",
                                marginBottom: "12px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (licensing_module_default()).skeletonRow,
                            style: {
                                height: "48px",
                                marginBottom: "12px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (licensing_module_default()).skeletonRow,
                            style: {
                                height: "48px",
                                marginBottom: "12px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (licensing_module_default()).skeletonRow,
                            style: {
                                height: "64px"
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var LicensingOptions_API_BASE_URL = LicensingOptions_process.env.NEXT_PUBLIC_API_BASE_URL || "https://api.vxfx.io" || 0;
var LicensingOptions = function() {
    var ref, ref1, ref2, ref3;
    var licensingQuery = (0,licensingService/* useLicensingSettings */.zH)();
    var state = licensingQuery.isLoading ? {
        status: "loading"
    } : licensingQuery.isError ? {
        status: "error",
        message: ((ref = licensingQuery.error) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) || ((ref3 = licensingQuery.error) === null || ref3 === void 0 ? void 0 : ref3.message) || "Failed to load licensing settings."
    } : licensingQuery.data ? {
        status: "success",
        data: licensingQuery.data
    } : {
        status: "idle"
    };
    var router = (0,next_router.useRouter)();
    // Get productId from slug in URL
    var slug = router.query.url || "";
    var productId = slug ? (0,products/* getProductIdBySlug */.WO)(slug) || "" : "";
    var ref4 = (0,react.useState)(false), binaryOpen = ref4[0], setBinaryOpen = ref4[1];
    var ref5 = (0,react.useState)(null), selectedPlanId = ref5[0], setSelectedPlanId = ref5[1];
    var ref6 = (0,react.useState)(false), confirmLoading = ref6[0], setConfirmLoading = ref6[1];
    var ref7 = (0,react.useState)(1040), modalWidth = ref7[0], setModalWidth = ref7[1];
    var ref8 = (0,react.useState)(false), isMobile = ref8[0], setIsMobile = ref8[1];
    var ref9 = (0,react.useState)(null), promotion = ref9[0], setPromotion = ref9[1];
    var ref10 = (0,react.useState)(false), promotionLoading = ref10[0], setPromotionLoading = ref10[1];
    var ref11 = (0,react.useState)("eur"), currency = ref11[0], setCurrency = ref11[1];
    var ref12 = (0,react.useState)("eur"), subscriptionCurrency = ref12[0], setSubscriptionCurrency = ref12[1];
    var ref13 = (0,react.useState)([]), packages = ref13[0], setPackages = ref13[1];
    var ref14 = (0,react.useState)(false), packagesLoading = ref14[0], setPackagesLoading = ref14[1];
    var ref15 = (0,react.useState)(null), selectedPackage = ref15[0], setSelectedPackage = ref15[1];
    var ref16 = (0,react.useState)(null), hoveredColumn = ref16[0], setHoveredColumn = ref16[1];
    var ref17 = (0,react.useState)("binary"), activeTab = ref17[0], setActiveTab = ref17[1];
    // Fetch promotion for product
    (0,react.useEffect)(function() {
        if (!productId) return;
        var mounted = true;
        var fetchPromotion = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, response, promotionData, e, ref1, ref2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            setPromotionLoading(true);
                            return [
                                4,
                                axios/* default.get */.Z.get("".concat(LicensingOptions_API_BASE_URL, "/promotions/product/").concat(productId, "/active"))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!mounted) return [
                                2
                            ];
                            promotionData = ((ref = response.data) === null || ref === void 0 ? void 0 : ref.data) !== undefined ? response.data.data : response.data;
                            // If response is null or empty, no active promotion
                            if (!promotionData) {
                                setPromotion(null);
                            } else if (promotionData.isActive) {
                                setPromotion(promotionData);
                            } else {
                                setPromotion(null);
                            }
                            return [
                                3,
                                4
                            ];
                        case 2:
                            e = _state.sent();
                            if (!mounted) return [
                                2
                            ];
                            // If 404 or no active promotion, set to null (not an error)
                            if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 404 || (e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 400) {
                                setPromotion(null);
                            } else {
                                console.error("Error fetching promotion:", e);
                                setPromotion(null);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            if (mounted) {
                                setPromotionLoading(false);
                            }
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPromotion() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPromotion();
        return function() {
            mounted = false;
        };
    }, [
        productId
    ]);
    // Detect user currency preference (can be enhanced later)
    (0,react.useEffect)(function() {
        // Simple detection - can be enhanced with user preference or geolocation
        var userLang =  true ? navigator.language : 0;
        if (userLang.toLowerCase().includes("eu") || userLang.toLowerCase().includes("de") || userLang.toLowerCase().includes("fr")) {
            setCurrency("eur");
        } else {
            setCurrency("eur");
        }
    }, []);
    // Fetch packages for product
    (0,react.useEffect)(function() {
        if (!productId) return;
        var mounted = true;
        var fetchPackages = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, response, token, allPackages, visiblePackages, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            setPackagesLoading(true);
                            return [
                                4,
                                axios/* default.get */.Z.get("".concat(LicensingOptions_API_BASE_URL, "/packages?productId=").concat(productId))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!mounted) return [
                                2
                            ];
                            if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.success) && ((ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.data)) {
                                token = localStorage.getItem("auth-token");
                                allPackages = response.data.data;
                                visiblePackages = allPackages.filter(function(pkg) {
                                    return !pkg.hidden;
                                });
                                // Reverse the array to match the correct order
                                setPackages(visiblePackages.reverse());
                            }
                            return [
                                3,
                                4
                            ];
                        case 2:
                            e = _state.sent();
                            if (!mounted) return [
                                2
                            ];
                            console.error("Error fetching packages:", e);
                            setPackages([]);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            if (mounted) {
                                setPackagesLoading(false);
                            }
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPackages() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPackages();
        return function() {
            mounted = false;
        };
    }, [
        productId
    ]);
    (0,react.useEffect)(function() {
        var mounted = true;
        var onResize = function() {
            if (!mounted) return;
            setIsMobile( true && window.innerWidth <= 480);
        };
        onResize();
        window.addEventListener("resize", onResize);
        return function() {
            mounted = false;
            window.removeEventListener("resize", onResize);
        };
    }, []);
    // Set initial active tab based on available options
    var showSubscriptionOption = state.status === "success" && state.data.showSubscription;
    var showBinaryOption = state.status === "success" && state.data.showBinary;
    (0,react.useEffect)(function() {
        if (state.status === "success") {
            var data = state.data;
            var showTabs = data.showSubscription && data.showBinary;
            if (showTabs) {
                // If both are available, default to binary
                setActiveTab("binary");
            } else if (data.showSubscription) {
                setActiveTab("subscription");
            } else if (data.showBinary) {
                setActiveTab("binary");
            }
        }
    // `state` is rebuilt as a new object every render (derived inline from
    // licensingQuery), so depending on it directly re-ran this effect - and
    // reset activeTab back to its default - on every click that changed
    // activeTab. Depend on the primitive values that should actually drive
    // the default tab instead.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.status,
        showSubscriptionOption,
        showBinaryOption
    ]);
    if (state.status === "loading" || state.status === "idle") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (licensing_module_default()).licensingContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (licensing_module_default()).licensingContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (licensing_module_default()).licensingHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                variant: "text-md",
                                color: "grayDark-300",
                                children: "Overview"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                variant: "display-md",
                                color: "grayDark-50",
                                weight: "semibold",
                                className: (licensing_module_default()).licensingTitle,
                                children: "Licensing Options"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LicensingSkeleton, {})
                ]
            })
        });
    }
    if (state.status === "error") {
        // Fail-safe: render nothing (per requirement), optional small message aside
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (licensing_module_default()).licensingContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (licensing_module_default()).licensingContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (licensing_module_default()).licensingHeader,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                        variant: "text-md",
                        color: "grayDark-400",
                        children: "Failed to load licensing settings."
                    })
                })
            })
        });
    }
    if (state.status !== "success") {
        return null;
    }
    var data = state.data;
    // Determine if we should show tabs (both are true)
    var showTabs = data.showSubscription && data.showBinary;
    // Find the highest step that still has available slots
    var getActiveStep = function(promotion) {
        if (!promotion || !promotion.steps || promotion.steps.length === 0) {
            return null;
        }
        // Sort steps by discountPercentage descending to find the highest available step
        var sortedSteps = (0,_to_consumable_array/* default */.Z)(promotion.steps).sort(function(a, b) {
            return b.discountPercentage - a.discountPercentage;
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Find the first step that still has available slots
            for(var _iterator = sortedSteps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var step = _step.value;
                var usedOrders = step.usedOrders || 0;
                if (usedOrders < step.maxOrders) {
                    return step;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    var activeStep = getActiveStep(promotion);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (licensing_module_default()).licensingContainer,
        id: "licensing-options",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (licensing_module_default()).licensingContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (licensing_module_default()).licensingHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                variant: "text-md",
                                color: "grayDark-300",
                                children: "Overview"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                variant: "display-md",
                                color: "grayDark-50",
                                weight: "semibold",
                                className: (licensing_module_default()).licensingTitle,
                                children: "Licensing Options"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                variant: "text-xl",
                                color: "grayDark-400",
                                children: "Select the license model that fits your usage and access level"
                            })
                        ]
                    }),
                    showTabs && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (licensing_module_default()).tabs,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                variant: "text-sm",
                                as: "p",
                                color: "secondary",
                                weight: "normal",
                                className: "".concat((licensing_module_default()).tabButton, " ").concat(activeTab === "binary" ? (licensing_module_default()).active : ""),
                                onClick: function() {
                                    return setActiveTab("binary");
                                },
                                children: "Binary"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                variant: "text-sm",
                                as: "p",
                                color: "secondary",
                                weight: "normal",
                                className: "".concat((licensing_module_default()).tabButton, " ").concat(activeTab === "subscription" ? (licensing_module_default()).active : ""),
                                onClick: function() {
                                    return setActiveTab("subscription");
                                },
                                children: "Subscriptions"
                            })
                        ]
                    }),
                    data.showSubscription && (!showTabs || activeTab === "subscription") && /*#__PURE__*/ (0,jsx_runtime.jsx)(bookpage_Subscriptions, {
                        currency: subscriptionCurrency,
                        onCurrencyChange: setSubscriptionCurrency
                    }),
                    data.showBinary && (!showTabs || activeTab === "binary") && packages.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (licensing_module_default()).packagesTableWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                    className: (licensing_module_default()).packagesTable,
                                    "data-hovered-column": hoveredColumn,
                                    onMouseLeave: function() {
                                        return setHoveredColumn(null);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        "data-column": "0"
                                                    }),
                                                    packages.map(function(pkg, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            "data-column": "".concat(index + 1),
                                                            onMouseEnter: function() {
                                                                return setHoveredColumn("".concat(index + 1));
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    gap: 4
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                        variant: "text-md",
                                                                        color: "grayDark-50",
                                                                        weight: "semibold",
                                                                        children: pkg.name
                                                                    }),
                                                                    pkg.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                        variant: "text-sm",
                                                                        color: "grayDark-400",
                                                                        children: pkg.subtitle
                                                                    })
                                                                ]
                                                            })
                                                        }, pkg._id);
                                                    }),
                                                    data.showSourceCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        "data-column": "".concat(packages.length + 1),
                                                        onMouseEnter: function() {
                                                            return setHoveredColumn("".concat(packages.length + 1));
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                            variant: "text-md",
                                                            color: "grayDark-50",
                                                            weight: "semibold",
                                                            children: "Source Code"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: (licensing_module_default()).highlightedRow,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-300",
                                                                weight: "medium",
                                                                children: "Supported hosts"
                                                            })
                                                        }),
                                                        packages.map(function(pkg, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                "data-column": "".concat(index + 1),
                                                                onMouseEnter: function() {
                                                                    return setHoveredColumn("".concat(index + 1));
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "grayDark-400",
                                                                    children: pkg.hostLimit.toLocaleString()
                                                                })
                                                            }, pkg._id);
                                                        }),
                                                        data.showSourceCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "".concat(packages.length + 1),
                                                            onMouseEnter: function() {
                                                                return setHoveredColumn("".concat(packages.length + 1));
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-300",
                                                                weight: "medium",
                                                                children: "Development machines"
                                                            })
                                                        }),
                                                        packages.map(function(pkg, index) {
                                                            var isLastPackage = index === packages.length - 1;
                                                            var displayValue = isLastPackage ? "".concat(pkg.hardwareLimit.toLocaleString(), "+") : pkg.hardwareLimit.toLocaleString();
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                "data-column": "".concat(index + 1),
                                                                onMouseEnter: function() {
                                                                    return setHoveredColumn("".concat(index + 1));
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "grayDark-400",
                                                                    children: displayValue
                                                                })
                                                            }, pkg._id);
                                                        }),
                                                        data.showSourceCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "".concat(packages.length + 1),
                                                            onMouseEnter: function() {
                                                                return setHoveredColumn("".concat(packages.length + 1));
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: (licensing_module_default()).highlightedRow,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-300",
                                                                weight: "medium",
                                                                children: "Normal price"
                                                            })
                                                        }),
                                                        packages.map(function(pkg, index) {
                                                            var hasPromotion = promotion && promotion.isActive;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                "data-column": "".concat(index + 1),
                                                                onMouseEnter: function() {
                                                                    return setHoveredColumn("".concat(index + 1));
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: hasPromotion ? "grayDark-300" : "grayDark-50",
                                                                    weight: hasPromotion ? undefined : "semibold",
                                                                    style: hasPromotion ? {
                                                                        textDecoration: "line-through",
                                                                        opacity: 0.6
                                                                    } : {},
                                                                    children: currency === "eur" ? "€".concat(pkg.price.eur.toLocaleString()) : "€".concat(pkg.price.eur.toLocaleString())
                                                                })
                                                            }, pkg._id);
                                                        }),
                                                        data.showSourceCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "".concat(packages.length + 1),
                                                            onMouseEnter: function() {
                                                                return setHoveredColumn("".concat(packages.length + 1));
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                promotion && promotion.isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (licensing_module_default()).preorderLabelContainer,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                        variant: "text-sm",
                                                                        color: "grayDark-300",
                                                                        weight: "medium",
                                                                        children: promotion.name
                                                                    }),
                                                                    activeStep && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                                        variant: "text-xs",
                                                                        className: (licensing_module_default()).preorderDescriptionLabel,
                                                                        children: [
                                                                            activeStep.discountPercentage,
                                                                            "% ",
                                                                            promotion.description
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        packages.map(function(pkg, index) {
                                                            // Calculate final price with discount from active step
                                                            var packagePrice = currency === "eur" ? pkg.price.eur : pkg.price.usd;
                                                            var finalPrice = activeStep ? packagePrice * (1 - activeStep.discountPercentage / 100) : packagePrice;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                "data-column": "".concat(index + 1),
                                                                onMouseEnter: function() {
                                                                    return setHoveredColumn("".concat(index + 1));
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    className: (licensing_module_default()).preorderPrice,
                                                                    children: currency === "eur" ? "€".concat(Math.round(finalPrice).toLocaleString()) : "€".concat(Math.round(finalPrice).toLocaleString())
                                                                })
                                                            }, pkg._id);
                                                        }),
                                                        data.showSourceCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "".concat(packages.length + 1),
                                                            onMouseEnter: function() {
                                                                return setHoveredColumn("".concat(packages.length + 1));
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (packages.some(function(pkg) {
                                                    return pkg.freeUpdateDuration !== undefined;
                                                }) || packages.some(function(pkg) {
                                                    return pkg.services && pkg.services.length > 0;
                                                })) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: (licensing_module_default()).highlightedRow,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "0",
                                                            style: {
                                                                verticalAlign: "top"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    gap: 4
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                        variant: "text-sm",
                                                                        color: "grayDark-300",
                                                                        weight: "medium",
                                                                        children: "Support Package"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                        variant: "text-xs",
                                                                        color: "grayDark-400",
                                                                        children: "(incl. Updates)"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        packages.map(function(pkg, index) {
                                                            var previousPackage = index > 0 ? packages[index - 1] : null;
                                                            var hasUpdateDuration = pkg.freeUpdateDuration !== undefined;
                                                            var hasServices = pkg.services && pkg.services.length > 0;
                                                            var hasContent = hasUpdateDuration || hasServices;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                "data-column": "".concat(index + 1),
                                                                onMouseEnter: function() {
                                                                    return setHoveredColumn("".concat(index + 1));
                                                                },
                                                                style: {
                                                                    verticalAlign: "top"
                                                                },
                                                                children: hasContent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        gap: 8,
                                                                        alignItems: "center",
                                                                        textAlign: "center"
                                                                    },
                                                                    children: [
                                                                        previousPackage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                                            variant: "text-sm",
                                                                            color: "grayDark-50",
                                                                            weight: "semibold",
                                                                            style: {
                                                                                fontSize: "14px",
                                                                                lineHeight: "1.4"
                                                                            },
                                                                            children: [
                                                                                "All in ",
                                                                                previousPackage.name
                                                                            ]
                                                                        }),
                                                                        hasUpdateDuration && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                                            variant: "text-sm",
                                                                            color: "grayDark-400",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    style: {
                                                                                        color: "var(--color-gray-dark-50)",
                                                                                        fontWeight: 600
                                                                                    },
                                                                                    children: pkg.freeUpdateDuration
                                                                                }),
                                                                                " mo. inclusive support"
                                                                            ]
                                                                        }),
                                                                        hasServices && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            style: {
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                gap: 4
                                                                            },
                                                                            children: pkg.services.map(function(service, idx) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                                    variant: "text-sm",
                                                                                    color: "grayDark-400",
                                                                                    children: service
                                                                                }, idx);
                                                                            })
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "grayDark-400",
                                                                    children: "—"
                                                                })
                                                            }, pkg._id);
                                                        }),
                                                        data.showSourceCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "".concat(packages.length + 1),
                                                            onMouseEnter: function() {
                                                                return setHoveredColumn("".concat(packages.length + 1));
                                                            },
                                                            style: {
                                                                verticalAlign: "top"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: (licensing_module_default()).actionRow,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "0"
                                                        }),
                                                        packages.map(function(pkg, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                "data-column": "".concat(index + 1),
                                                                onMouseEnter: function() {
                                                                    return setHoveredColumn("".concat(index + 1));
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                                                                    variant: "primary",
                                                                    onClick: function() {
                                                                        setSelectedPackage(pkg);
                                                                        setBinaryOpen(true);
                                                                    },
                                                                    fullWidth: true,
                                                                    children: promotion && promotion.isActive ? promotion.name : "Select"
                                                                })
                                                            }, pkg._id);
                                                        }),
                                                        data.showSourceCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            "data-column": "".concat(packages.length + 1),
                                                            onMouseEnter: function() {
                                                                return setHoveredColumn("".concat(packages.length + 1));
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                                                                variant: "primary",
                                                                href: "/contact-us",
                                                                fullWidth: true,
                                                                children: "Contact us"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (licensing_module_default()).packagesCardWrapper,
                                children: [
                                    packages.map(function(pkg, index) {
                                        var previousPackage = index > 0 ? packages[index - 1] : null;
                                        var hasUpdateDuration = pkg.freeUpdateDuration !== undefined;
                                        var hasServices = pkg.services && pkg.services.length > 0;
                                        var hasSupportContent = hasUpdateDuration || hasServices;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (licensing_module_default()).packageCard,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (licensing_module_default()).packageCardHeader,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 4
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-md",
                                                                color: "grayDark-50",
                                                                weight: "semibold",
                                                                children: pkg.name
                                                            }),
                                                            pkg.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: pkg.subtitle
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (licensing_module_default()).packageCardContent,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (licensing_module_default()).packageCardRow,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "grayDark-300",
                                                                    weight: "medium",
                                                                    children: "Supported hosts"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "grayDark-400",
                                                                    children: pkg.hostLimit.toLocaleString()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (licensing_module_default()).packageCardRow,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "grayDark-300",
                                                                    weight: "medium",
                                                                    children: "Development machines"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "grayDark-400",
                                                                    children: index === packages.length - 1 ? "".concat(pkg.hardwareLimit.toLocaleString(), "+") : pkg.hardwareLimit.toLocaleString()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((licensing_module_default()).packageCardRow, " ").concat((licensing_module_default()).highlightedCardRow),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "grayDark-300",
                                                                    weight: "medium",
                                                                    children: "Normal price"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: promotion && promotion.isActive ? "grayDark-400" : "grayDark-50",
                                                                    weight: promotion && promotion.isActive ? undefined : "semibold",
                                                                    style: promotion && promotion.isActive ? {
                                                                        textDecoration: "line-through",
                                                                        opacity: 0.6
                                                                    } : {},
                                                                    children: currency === "eur" ? "€".concat(pkg.price.eur.toLocaleString()) : "€".concat(pkg.price.eur.toLocaleString())
                                                                })
                                                            ]
                                                        }),
                                                        promotion && promotion.isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (licensing_module_default()).packageCardRow,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (licensing_module_default()).preorderLabelContainer,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                            variant: "text-sm",
                                                                            color: "grayDark-300",
                                                                            weight: "medium",
                                                                            children: promotion.name
                                                                        }),
                                                                        activeStep && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                                            variant: "text-xs",
                                                                            className: (licensing_module_default()).preorderDescriptionLabel,
                                                                            children: [
                                                                                activeStep.discountPercentage,
                                                                                "% ",
                                                                                promotion.description
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                function() {
                                                                    // Calculate final price with discount from active step for mobile view
                                                                    // We need to get the package price, but in mobile view we're inside packages.map
                                                                    // So we'll calculate it per package
                                                                    var packagePrice = currency === "eur" ? pkg.price.eur : pkg.price.usd;
                                                                    var finalPrice = activeStep ? packagePrice * (1 - activeStep.discountPercentage / 100) : packagePrice;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                        variant: "text-sm",
                                                                        className: (licensing_module_default()).preorderPrice,
                                                                        children: currency === "eur" ? "€".concat(Math.round(finalPrice).toLocaleString()) : "€".concat(Math.round(finalPrice).toLocaleString())
                                                                    });
                                                                }()
                                                            ]
                                                        }),
                                                        hasSupportContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((licensing_module_default()).packageCardRow, " ").concat((licensing_module_default()).highlightedCardRow),
                                                            style: {
                                                                alignItems: "flex-start"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        gap: 4
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                            variant: "text-sm",
                                                                            color: "grayDark-300",
                                                                            weight: "medium",
                                                                            children: "Support Package"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                            variant: "text-xs",
                                                                            color: "grayDark-400",
                                                                            children: "(incl. Updates)"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        gap: 8,
                                                                        alignItems: "flex-end",
                                                                        textAlign: "right"
                                                                    },
                                                                    children: [
                                                                        previousPackage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                                            variant: "text-sm",
                                                                            color: "grayDark-50",
                                                                            weight: "semibold",
                                                                            style: {
                                                                                fontSize: "14px",
                                                                                lineHeight: "1.4"
                                                                            },
                                                                            children: [
                                                                                "All in ",
                                                                                previousPackage.name
                                                                            ]
                                                                        }),
                                                                        hasUpdateDuration && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* Typography */.ZT, {
                                                                            variant: "text-sm",
                                                                            color: "grayDark-400",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    style: {
                                                                                        color: "var(--color-gray-dark-50)",
                                                                                        fontWeight: 600
                                                                                    },
                                                                                    children: pkg.freeUpdateDuration
                                                                                }),
                                                                                " mo. inclusive support"
                                                                            ]
                                                                        }),
                                                                        hasServices && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            style: {
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                gap: 4,
                                                                                alignItems: "flex-end"
                                                                            },
                                                                            children: pkg.services.map(function(service, idx) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                                    variant: "text-sm",
                                                                                    color: "grayDark-400",
                                                                                    children: service
                                                                                }, idx);
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (licensing_module_default()).packageCardFooter,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                                                        variant: "primary",
                                                        onClick: function() {
                                                            setSelectedPackage(pkg);
                                                            setBinaryOpen(true);
                                                        },
                                                        fullWidth: true,
                                                        children: promotion && promotion.isActive ? promotion.name : "Select"
                                                    })
                                                })
                                            ]
                                        }, pkg._id);
                                    }),
                                    data.showSourceCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (licensing_module_default()).packageCard,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (licensing_module_default()).packageCardHeader,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                    variant: "text-md",
                                                    color: "grayDark-50",
                                                    weight: "semibold",
                                                    children: "Source Code"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (licensing_module_default()).packageCardContent,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (licensing_module_default()).packageCardRow,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-300",
                                                                weight: "medium",
                                                                children: "Supported hosts"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (licensing_module_default()).packageCardRow,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-300",
                                                                weight: "medium",
                                                                children: "Development machines"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((licensing_module_default()).packageCardRow, " ").concat((licensing_module_default()).highlightedCardRow),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-300",
                                                                weight: "medium",
                                                                children: "Normal price"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (licensing_module_default()).packageCardRow,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-300",
                                                                weight: "medium",
                                                                children: "Pre order"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((licensing_module_default()).packageCardRow, " ").concat((licensing_module_default()).highlightedCardRow),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-300",
                                                                weight: "medium",
                                                                children: "Free updates & new features"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (licensing_module_default()).packageCardRow,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-300",
                                                                weight: "medium",
                                                                children: "Support package"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* Typography */.ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: "—"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (licensing_module_default()).packageCardFooter,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                                                    variant: "primary",
                                                    href: "/contact-us",
                                                    fullWidth: true,
                                                    children: "Contact us"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    data.showBinary && packagesLoading && packages.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (licensing_module_default()).packagesTableWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (licensing_module_default()).tableSkeleton,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (licensing_module_default()).skeletonRow
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (licensing_module_default()).skeletonRow
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (licensing_module_default()).skeletonRow
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bookpage_BinaryModal, {
                isOpen: binaryOpen,
                onClose: function() {
                    setBinaryOpen(false);
                    setSelectedPackage(null);
                },
                topOffset: isMobile ? 56 : 72,
                productId: productId,
                selectedPackage: selectedPackage
            })
        ]
    });
};
/* harmony default export */ var bookpage_LicensingOptions = (LicensingOptions);


/***/ }),

/***/ 63711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ updateLicensingSettings; },
/* harmony export */   "dO": function() { return /* binding */ fetchLicensingSettings; },
/* harmony export */   "zH": function() { return /* binding */ useLicensingSettings; }
/* harmony export */ });
/* unused harmony exports LICENSING_SETTINGS_QUERY_KEY, useInvalidateLicensingSettings */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15767);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81944);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86607);
/* provided dependency */ var process = __webpack_require__(82985);




var API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || "https://api.vxfx.io" || 0;
function fetchLicensingSettings() {
    return _fetchLicensingSettings.apply(this, arguments);
}
function _fetchLicensingSettings() {
    _fetchLicensingSettings = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var ref, res, ref1, payload;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat(API_BASE_URL, "/licensing"))
                    ];
                case 1:
                    res = _state.sent();
                    payload = (ref1 = (ref = res.data) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : res.data;
                    return [
                        2,
                        {
                            showSubscription: Boolean(payload === null || payload === void 0 ? void 0 : payload.showSubscription),
                            showBinary: Boolean(payload === null || payload === void 0 ? void 0 : payload.showBinary),
                            showSourceCode: Boolean(payload === null || payload === void 0 ? void 0 : payload.showSourceCode)
                        }
                    ];
            }
        });
    });
    return _fetchLicensingSettings.apply(this, arguments);
}
function updateLicensingSettings(payload) {
    return _updateLicensingSettings.apply(this, arguments);
}
function _updateLicensingSettings() {
    _updateLicensingSettings = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(payload) {
        var ref, token, res, ref1, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    token =  true ? localStorage.getItem("auth-token") : 0;
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].patch */ .Z.patch("".concat(API_BASE_URL, "/licensing"), payload, {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: token ? "Bearer ".concat(token) : ""
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    data = (ref1 = (ref = res.data) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : res.data;
                    return [
                        2,
                        {
                            showSubscription: Boolean(data === null || data === void 0 ? void 0 : data.showSubscription),
                            showBinary: Boolean(data === null || data === void 0 ? void 0 : data.showBinary),
                            showSourceCode: Boolean(data === null || data === void 0 ? void 0 : data.showSourceCode)
                        }
                    ];
            }
        });
    });
    return _updateLicensingSettings.apply(this, arguments);
}
var LICENSING_SETTINGS_QUERY_KEY = [
    "licensing-settings"
];
// Shared across every component that reads licensing settings (BookPageHome,
// LicensingOptions, ...) so they hit the API once and share one cached result
// instead of each mounting its own fetch.
function useLicensingSettings() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(LICENSING_SETTINGS_QUERY_KEY, fetchLicensingSettings, {
        staleTime: 60000
    });
}
function useInvalidateLicensingSettings() {
    var queryClient = useQueryClient();
    return function() {
        return queryClient.invalidateQueries(LICENSING_SETTINGS_QUERY_KEY);
    };
}


/***/ }),

/***/ 42172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleWrap":"binary_titleWrap__ljKHL","titleIcon":"binary_titleIcon___k_AD","titleText":"binary_titleText__chddd","grid":"binary_grid__XeS_Y","hostCard":"binary_hostCard__WoACt","disabled":"binary_disabled__pmkRr","selected":"binary_selected__DrvWR","hostLeft":"binary_hostLeft__M3QAP","check":"binary_check__2_PPn","footerBar":"binary_footerBar__5VkDk","total":"binary_total__C9NgB","footerActions":"binary_footerActions__9ncKV","osPills":"binary_osPills__kd3XY","stepTwoList":"binary_stepTwoList__ricCH","osRowCard":"binary_osRowCard__2kxZK","osRowHeader":"binary_osRowHeader__TyoZ0","osPill":"binary_osPill__MWeHj","osPillLabel":"binary_osPillLabel__ed9hI","osPillCheck":"binary_osPillCheck__4UA2j","osPillActive":"binary_osPillActive__xpG_f","contentDisabled":"binary_contentDisabled__sYjRV","hostSkeletonCard":"binary_hostSkeletonCard__MTRLq","hostSkeletonLeft":"binary_hostSkeletonLeft__4Q57r","hostSkeletonIcon":"binary_hostSkeletonIcon__xOdRg","skeletonLoading":"binary_skeletonLoading__pfD43","hostSkeletonText":"binary_hostSkeletonText__EWgmU","hostSkeletonCheck":"binary_hostSkeletonCheck__FLu76","step1Content":"binary_step1Content__K6ZRd","selectedPackageCard":"binary_selectedPackageCard__wA5UE","selectedPackageIcon":"binary_selectedPackageIcon__Q25qA","selectedPackageText":"binary_selectedPackageText__L8yUL","selectedPackageTitleRow":"binary_selectedPackageTitleRow__VK_z7","additionalOptions":"binary_additionalOptions__Jz871","optionField":"binary_optionField__9JrlA","optionFieldHeader":"binary_optionFieldHeader__p0BpK","tooltipIcon":"binary_tooltipIcon__5QCP_","priceSummary":"binary_priceSummary__8Fy6h","priceRow":"binary_priceRow__T6sIa","priceRowTotal":"binary_priceRowTotal__LjYbR","priceValues":"binary_priceValues__yG5WU","tooltipOverlay":"binary_tooltipOverlay__dpKmF"};

/***/ }),

/***/ 84429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"licensingContainer":"licensing_licensingContainer__gztbW","licensingContent":"licensing_licensingContent__mFdOU","licensingHeader":"licensing_licensingHeader__c5kr4","tabs":"licensing_tabs__dWnuC","tabButton":"licensing_tabButton__41qyH","active":"licensing_active__F678n","licensingTitle":"licensing_licensingTitle__Ofh1W","plansGrid":"licensing_plansGrid__rg_oQ","singleGrid":"licensing_singleGrid__bxE9h","singleCardWrapper":"licensing_singleCardWrapper__bECE4","twoGrid":"licensing_twoGrid__g3wRq","planCard":"licensing_planCard__4KK5J","planHeader":"licensing_planHeader__lTz80","planFeatures":"licensing_planFeatures__OXQXU","planCta":"licensing_planCta__F405_","packagesTableWrapper":"licensing_packagesTableWrapper__prh__","packagesCardWrapper":"licensing_packagesCardWrapper__uQ0bD","packageCard":"licensing_packageCard__ToMMq","packageCardHeader":"licensing_packageCardHeader__roIaH","packageCardContent":"licensing_packageCardContent__Ob_3X","packageCardRow":"licensing_packageCardRow__lcYdd","highlightedCardRow":"licensing_highlightedCardRow__xl_Gy","packageCardFooter":"licensing_packageCardFooter__iav2t","packagesTable":"licensing_packagesTable__g3HZR","highlightedRow":"licensing_highlightedRow__0CYs2","actionRow":"licensing_actionRow__0EBD0","columnHoverPulse":"licensing_columnHoverPulse__K46LH","columnHoverPulseHighlight":"licensing_columnHoverPulseHighlight__iHxYK","preorderLabelContainer":"licensing_preorderLabelContainer__5FgRS","preorderDescriptionLabel":"licensing_preorderDescriptionLabel__LGCyi","preorderPriceContainer":"licensing_preorderPriceContainer__ghrON","preorderPrice":"licensing_preorderPrice__w6Sfm","preorderDescription":"licensing_preorderDescription__uCZ0S","tableSkeleton":"licensing_tableSkeleton__DT0Il","skeletonRow":"licensing_skeletonRow__1UcLW","skeleton-loading":"licensing_skeleton-loading__qp8gW","skeletonTab":"licensing_skeletonTab__bXkpi"};

/***/ }),

/***/ 87100:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subscriptionsContainer":"subscriptions_subscriptionsContainer__IxtP3","modalContainer":"subscriptions_modalContainer___G53w","subscriptionsContent":"subscriptions_subscriptionsContent__GA5S6","modalContent":"subscriptions_modalContent__9lBRx","modalCard":"subscriptions_modalCard__YgBGr","modalPlansGrid":"subscriptions_modalPlansGrid__JECdP","subscriptionsHeader":"subscriptions_subscriptionsHeader__hYpqw","pattern":"subscriptions_pattern__N5_Cc","modalHeader":"subscriptions_modalHeader__GRP3w","modalHeaderTop":"subscriptions_modalHeaderTop__2_eqN","modalHeaderIconContainer":"subscriptions_modalHeaderIconContainer__ig3k5","modalHeaderIcon":"subscriptions_modalHeaderIcon__LDlXu","subscriptionsTitle":"subscriptions_subscriptionsTitle__yX2bz","plansGrid":"subscriptions_plansGrid__jgzpb","singleGrid":"subscriptions_singleGrid__PzLKf","singleCardWrapper":"subscriptions_singleCardWrapper__evwJp","twoGrid":"subscriptions_twoGrid__WM4Ec","planCard":"subscriptions_planCard__zn50h","selectable":"subscriptions_selectable__6otTy","selected":"subscriptions_selected__90dVV","popular":"subscriptions_popular__aJ9SV","popularBadge":"subscriptions_popularBadge__PI52_","selectIndicator":"subscriptions_selectIndicator__PLL02","selectDot":"subscriptions_selectDot__Xsad_","planHeader":"subscriptions_planHeader__NYCaj","planPrice":"subscriptions_planPrice__rMnwF","planButtons":"subscriptions_planButtons__jRQO5","planFeatures":"subscriptions_planFeatures__NGkpx","noDivider":"subscriptions_noDivider__FeMHS","featuresTitle":"subscriptions_featuresTitle__w3V2e","featuresSubtitle":"subscriptions_featuresSubtitle__4vJm5","featuresList":"subscriptions_featuresList__UXrWr","modalFeaturesList":"subscriptions_modalFeaturesList__P6_iQ","featureItem":"subscriptions_featureItem__q64qS","planCta":"subscriptions_planCta__nCS9X","loading":"subscriptions_loading__c2V2A","contentDisabled":"subscriptions_contentDisabled__Hq5BW","skeletonGrid":"subscriptions_skeletonGrid__PXM_T","skeletonCard":"subscriptions_skeletonCard__dZ1qE","skeletonHeaderLine":"subscriptions_skeletonHeaderLine__KbjVv","subscriptionsSkeletonLoading":"subscriptions_subscriptionsSkeletonLoading__lDlRn","skeletonLine":"subscriptions_skeletonLine__lX5PK","skeletonFooterLine":"subscriptions_skeletonFooterLine__TWMWB","skeletonIcon":"subscriptions_skeletonIcon__o7RBh","skeleton-loading":"subscriptions_skeleton-loading__DfTgF","skeletonTitle":"subscriptions_skeletonTitle__quOZv","skeletonPrice":"subscriptions_skeletonPrice__V3CPQ","skeletonFeature":"subscriptions_skeletonFeature__dgaeE","skeletonCheckIcon":"subscriptions_skeletonCheckIcon__FDuEO","skeletonFeatureText":"subscriptions_skeletonFeatureText__2h80K","skeletonButtonContainer":"subscriptions_skeletonButtonContainer___TH6W","skeletonButton":"subscriptions_skeletonButton__vFrqf","planMeta":"subscriptions_planMeta__F7CTK"};

/***/ }),

/***/ 44454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.2.0/node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.2.0/node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.2.0/node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.2.0/node_modules/react-icons/lib/esm/index.js




/***/ }),

/***/ 57135:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

}]);